webpackJsonp([14],{

/***/ 407:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Provider_vue__ = __webpack_require__(738);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9d98522c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Provider_vue__ = __webpack_require__(926);
function injectStyle (ssrContext) {
  __webpack_require__(919)
}
var normalizeComponent = __webpack_require__(56)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9d98522c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Provider_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9d98522c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Provider_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 465:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "withParams", {
  enumerable: true,
  get: function get() {
    return _withParams.default;
  }
});
exports.regex = exports.ref = exports.len = exports.req = void 0;

var _withParams = _interopRequireDefault(__webpack_require__(469));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var req = function req(value) {
  if (Array.isArray(value)) return !!value.length;

  if (value === undefined || value === null) {
    return false;
  }

  if (value === false) {
    return true;
  }

  if (value instanceof Date) {
    return !isNaN(value.getTime());
  }

  if (_typeof(value) === 'object') {
    for (var _ in value) {
      return true;
    }

    return false;
  }

  return !!String(value).length;
};

exports.req = req;

var len = function len(value) {
  if (Array.isArray(value)) return value.length;

  if (_typeof(value) === 'object') {
    return Object.keys(value).length;
  }

  return String(value).length;
};

exports.len = len;

var ref = function ref(reference, vm, parentVm) {
  return typeof reference === 'function' ? reference.call(vm, parentVm) : parentVm[reference];
};

exports.ref = ref;

var regex = function regex(type, expr) {
  return (0, _withParams.default)({
    type: type
  }, function (value) {
    return !req(value) || expr.test(value);
  });
};

exports.regex = regex;

/***/ }),

/***/ 466:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "alpha", {
  enumerable: true,
  get: function get() {
    return _alpha.default;
  }
});
Object.defineProperty(exports, "alphaNum", {
  enumerable: true,
  get: function get() {
    return _alphaNum.default;
  }
});
Object.defineProperty(exports, "numeric", {
  enumerable: true,
  get: function get() {
    return _numeric.default;
  }
});
Object.defineProperty(exports, "between", {
  enumerable: true,
  get: function get() {
    return _between.default;
  }
});
Object.defineProperty(exports, "email", {
  enumerable: true,
  get: function get() {
    return _email.default;
  }
});
Object.defineProperty(exports, "ipAddress", {
  enumerable: true,
  get: function get() {
    return _ipAddress.default;
  }
});
Object.defineProperty(exports, "macAddress", {
  enumerable: true,
  get: function get() {
    return _macAddress.default;
  }
});
Object.defineProperty(exports, "maxLength", {
  enumerable: true,
  get: function get() {
    return _maxLength.default;
  }
});
Object.defineProperty(exports, "minLength", {
  enumerable: true,
  get: function get() {
    return _minLength.default;
  }
});
Object.defineProperty(exports, "required", {
  enumerable: true,
  get: function get() {
    return _required.default;
  }
});
Object.defineProperty(exports, "requiredIf", {
  enumerable: true,
  get: function get() {
    return _requiredIf.default;
  }
});
Object.defineProperty(exports, "requiredUnless", {
  enumerable: true,
  get: function get() {
    return _requiredUnless.default;
  }
});
Object.defineProperty(exports, "sameAs", {
  enumerable: true,
  get: function get() {
    return _sameAs.default;
  }
});
Object.defineProperty(exports, "url", {
  enumerable: true,
  get: function get() {
    return _url.default;
  }
});
Object.defineProperty(exports, "or", {
  enumerable: true,
  get: function get() {
    return _or.default;
  }
});
Object.defineProperty(exports, "and", {
  enumerable: true,
  get: function get() {
    return _and.default;
  }
});
Object.defineProperty(exports, "not", {
  enumerable: true,
  get: function get() {
    return _not.default;
  }
});
Object.defineProperty(exports, "minValue", {
  enumerable: true,
  get: function get() {
    return _minValue.default;
  }
});
Object.defineProperty(exports, "maxValue", {
  enumerable: true,
  get: function get() {
    return _maxValue.default;
  }
});
Object.defineProperty(exports, "integer", {
  enumerable: true,
  get: function get() {
    return _integer.default;
  }
});
Object.defineProperty(exports, "decimal", {
  enumerable: true,
  get: function get() {
    return _decimal.default;
  }
});
exports.helpers = void 0;

var _alpha = _interopRequireDefault(__webpack_require__(468));

var _alphaNum = _interopRequireDefault(__webpack_require__(471));

var _numeric = _interopRequireDefault(__webpack_require__(472));

var _between = _interopRequireDefault(__webpack_require__(473));

var _email = _interopRequireDefault(__webpack_require__(474));

var _ipAddress = _interopRequireDefault(__webpack_require__(475));

var _macAddress = _interopRequireDefault(__webpack_require__(476));

var _maxLength = _interopRequireDefault(__webpack_require__(477));

var _minLength = _interopRequireDefault(__webpack_require__(478));

var _required = _interopRequireDefault(__webpack_require__(479));

var _requiredIf = _interopRequireDefault(__webpack_require__(480));

var _requiredUnless = _interopRequireDefault(__webpack_require__(481));

var _sameAs = _interopRequireDefault(__webpack_require__(482));

var _url = _interopRequireDefault(__webpack_require__(483));

var _or = _interopRequireDefault(__webpack_require__(484));

var _and = _interopRequireDefault(__webpack_require__(485));

var _not = _interopRequireDefault(__webpack_require__(486));

var _minValue = _interopRequireDefault(__webpack_require__(487));

var _maxValue = _interopRequireDefault(__webpack_require__(488));

var _integer = _interopRequireDefault(__webpack_require__(489));

var _decimal = _interopRequireDefault(__webpack_require__(490));

var helpers = _interopRequireWildcard(__webpack_require__(465));

exports.helpers = helpers;

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 467:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    idModal: {
      type: String,
      default: "deletemodal"
    },
    subContent: {
      type: String,
      default: "Do you want to delete this record? This process cannot be undone."
    }
  },
  methods: {
    cancel: function cancel() {
      $("#" + this.idModal).modal("hide");
      this.$emit("cancel");
    },
    submit: function submit() {
      $("#" + this.idModal).modal("hide");
      this.$emit("submit");
    }
  }
});

/***/ }),

/***/ 468:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = (0, _common.regex)('alpha', /^[a-zA-Z]*$/);

exports.default = _default;

/***/ }),

/***/ 469:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var withParams = Object({"NODE_ENV":"production","BRAND_NAME":"Trransfer","VUE_APP_GOOGLE_MAPS_KEY":"AIzaSyDwoOCBqFXIhPMWg922paZIpeVZkudwH6I","VUE_APP_BASE_API":"https://prod-gateway-opsicar.idteknologia.net","VUE_APP_AUTH_HOST":"https://authservice.trransfer.com","VUE_APP_CDN":"https://maverick-global-assets-cp52hf.s3.ap-southeast-1.amazonaws.com","VUE_APP_GOOGLE_TAG_ID":"UA-171512499-1","VUE_APP_SUPPORT_WIDGET_ID":"51000003059","VUE_APP_SUPPORT_WIDGET_SOURCE":"https://aus-widget.freshworks.com/widgets/51000003059.js"}).BUILD === 'web' ? __webpack_require__(470).withParams : __webpack_require__(235).withParams;
var _default = withParams;
exports.default = _default;

/***/ }),

/***/ 470:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withParams = void 0;

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var root = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : {};

var fakeWithParams = function fakeWithParams(paramsOrClosure, maybeValidator) {
  if (_typeof(paramsOrClosure) === 'object' && maybeValidator !== undefined) {
    return maybeValidator;
  }

  return paramsOrClosure(function () {});
};

var withParams = root.vuelidate ? root.vuelidate.withParams : fakeWithParams;
exports.withParams = withParams;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),

/***/ 471:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = (0, _common.regex)('alphaNum', /^[a-zA-Z0-9]*$/);

exports.default = _default;

/***/ }),

/***/ 472:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = (0, _common.regex)('numeric', /^[0-9]*$/);

exports.default = _default;

/***/ }),

/***/ 473:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(min, max) {
  return (0, _common.withParams)({
    type: 'between',
    min: min,
    max: max
  }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +min <= +value && +max >= +value;
  });
};

exports.default = _default;

/***/ }),

/***/ 474:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var emailRegex = /^(?:[A-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9]{2,}(?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/;

var _default = (0, _common.regex)('email', emailRegex);

exports.default = _default;

/***/ }),

/***/ 475:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = (0, _common.withParams)({
  type: 'ipAddress'
}, function (value) {
  if (!(0, _common.req)(value)) {
    return true;
  }

  if (typeof value !== 'string') {
    return false;
  }

  var nibbles = value.split('.');
  return nibbles.length === 4 && nibbles.every(nibbleValid);
});

exports.default = _default;

var nibbleValid = function nibbleValid(nibble) {
  if (nibble.length > 3 || nibble.length === 0) {
    return false;
  }

  if (nibble[0] === '0' && nibble !== '0') {
    return false;
  }

  if (!nibble.match(/^\d+$/)) {
    return false;
  }

  var numeric = +nibble | 0;
  return numeric >= 0 && numeric <= 255;
};

/***/ }),

/***/ 476:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default() {
  var separator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ':';
  return (0, _common.withParams)({
    type: 'macAddress'
  }, function (value) {
    if (!(0, _common.req)(value)) {
      return true;
    }

    if (typeof value !== 'string') {
      return false;
    }

    var parts = typeof separator === 'string' && separator !== '' ? value.split(separator) : value.length === 12 || value.length === 16 ? value.match(/.{2}/g) : null;
    return parts !== null && (parts.length === 6 || parts.length === 8) && parts.every(hexValid);
  });
};

exports.default = _default;

var hexValid = function hexValid(hex) {
  return hex.toLowerCase().match(/^[0-9a-f]{2}$/);
};

/***/ }),

/***/ 477:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(length) {
  return (0, _common.withParams)({
    type: 'maxLength',
    max: length
  }, function (value) {
    return !(0, _common.req)(value) || (0, _common.len)(value) <= length;
  });
};

exports.default = _default;

/***/ }),

/***/ 478:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(length) {
  return (0, _common.withParams)({
    type: 'minLength',
    min: length
  }, function (value) {
    return !(0, _common.req)(value) || (0, _common.len)(value) >= length;
  });
};

exports.default = _default;

/***/ }),

/***/ 479:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = (0, _common.withParams)({
  type: 'required'
}, function (value) {
  if (typeof value === 'string') {
    return (0, _common.req)(value.trim());
  }

  return (0, _common.req)(value);
});

exports.default = _default;

/***/ }),

/***/ 480:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(prop) {
  return (0, _common.withParams)({
    type: 'requiredIf',
    prop: prop
  }, function (value, parentVm) {
    return (0, _common.ref)(prop, this, parentVm) ? (0, _common.req)(value) : true;
  });
};

exports.default = _default;

/***/ }),

/***/ 481:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(prop) {
  return (0, _common.withParams)({
    type: 'requiredUnless',
    prop: prop
  }, function (value, parentVm) {
    return !(0, _common.ref)(prop, this, parentVm) ? (0, _common.req)(value) : true;
  });
};

exports.default = _default;

/***/ }),

/***/ 482:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(equalTo) {
  return (0, _common.withParams)({
    type: 'sameAs',
    eq: equalTo
  }, function (value, parentVm) {
    return value === (0, _common.ref)(equalTo, this, parentVm);
  });
};

exports.default = _default;

/***/ }),

/***/ 483:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var urlRegex = /^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i;

var _default = (0, _common.regex)('url', urlRegex);

exports.default = _default;

/***/ }),

/***/ 484:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default() {
  for (var _len = arguments.length, validators = new Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  return (0, _common.withParams)({
    type: 'or'
  }, function () {
    var _this = this;

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return validators.length > 0 && validators.reduce(function (valid, fn) {
      return valid || fn.apply(_this, args);
    }, false);
  });
};

exports.default = _default;

/***/ }),

/***/ 485:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default() {
  for (var _len = arguments.length, validators = new Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  return (0, _common.withParams)({
    type: 'and'
  }, function () {
    var _this = this;

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return validators.length > 0 && validators.reduce(function (valid, fn) {
      return valid && fn.apply(_this, args);
    }, true);
  });
};

exports.default = _default;

/***/ }),

/***/ 486:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(validator) {
  return (0, _common.withParams)({
    type: 'not'
  }, function (value, vm) {
    return !(0, _common.req)(value) || !validator.call(this, value, vm);
  });
};

exports.default = _default;

/***/ }),

/***/ 487:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(min) {
  return (0, _common.withParams)({
    type: 'minValue',
    min: min
  }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +value >= +min;
  });
};

exports.default = _default;

/***/ }),

/***/ 488:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(max) {
  return (0, _common.withParams)({
    type: 'maxValue',
    max: max
  }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +value <= +max;
  });
};

exports.default = _default;

/***/ }),

/***/ 489:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = (0, _common.regex)('integer', /(^[0-9]*$)|(^-[0-9]+$)/);

exports.default = _default;

/***/ }),

/***/ 490:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = (0, _common.regex)('decimal', /^[-]?\d*(\.\d+)?$/);

exports.default = _default;

/***/ }),

/***/ 491:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeleteModal_vue__ = __webpack_require__(467);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f6d05f94_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeleteModal_vue__ = __webpack_require__(492);
var normalizeComponent = __webpack_require__(56)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeleteModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f6d05f94_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeleteModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 492:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal fade",attrs:{"role":"dialog","id":_vm.idModal}},[_c('div',{staticClass:"modal-dialog modal-xs"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-body modal-confirmation"},[_c('div',{staticClass:"row text-center"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"modal-wrapper"},[_vm._m(0),_vm._v(" "),_c('header',[_vm._v("Are you sure?")]),_vm._v(" "),_c('p',[_vm._v("\n                "+_vm._s(_vm.subContent)+"\n              ")]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button"},on:{"click":_vm.cancel}},[_vm._v("\n                  Cancel\n                ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"type":"submit"},on:{"click":_vm.submit}},[_vm._v("\n                  Yes, delete\n                ")])])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"delete-icon"},[_c('i',{staticClass:"ic-close"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 495:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(498), __esModule: true };

/***/ }),

/***/ 496:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(57);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),

/***/ 498:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(36);
__webpack_require__(25);
module.exports = __webpack_require__(499);


/***/ }),

/***/ 499:
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(8);
var get = __webpack_require__(58);
module.exports = __webpack_require__(1).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),

/***/ 500:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export syncApi */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return asyncApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);



var _this = this;




var _guardCallback = function _guardCallback(arg) {
  if (typeof arg === "function") {
    arg();
  }
};

var _onError = function _onError(error) {
  if (error.response) {
    if (error.response.data.errors) {
      if (Array.isArray(error.response.data.errors)) {
        for (var index = 0; index < error.response.data.errors.length; index++) {
          __WEBPACK_IMPORTED_MODULE_2__main__["default"].$notification.error(error.response.data.errors[index], {
            title: "Error"
          });
        }
      } else {
        for (var prop in error.response.data.errors) {
          if (!error.response.data.errors.hasOwnProperty(prop)) {
            continue;
          }
          __WEBPACK_IMPORTED_MODULE_2__main__["default"].$notification.error(error.response.data.errors[prop][0], {
            title: "Error"
          });
        }
      }
    } else {
      __WEBPACK_IMPORTED_MODULE_2__main__["default"].$notification.error("Request failed with status code " + error.response.status, { title: "Error" });
    }
  } else if (error.request) {
    __WEBPACK_IMPORTED_MODULE_2__main__["default"].$notification.error("Something wrong with request messages.", {
      title: "Error"
    });
  } else {
    __WEBPACK_IMPORTED_MODULE_2__main__["default"].$notification.error("Something went wrong, please try again later.", {
      title: "Error"
    });
  }

  return {
    isSuccess: false
  };
};

var syncApi = {
  get: function get(url, onBeginCallback, onFinallyCallback) {
    _guardCallback(onBeginCallback);

    return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url).then(function (response) {
      return response.data;
    }).catch(function (error) {
      return _onError(error);
    }).finally(function () {
      _guardCallback(onFinallyCallback);
    });
  },
  post: function post(url, payload, onBeginCallback, onFinallyCallback) {
    _guardCallback(onBeginCallback);

    return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(url, payload).then(function (response) {
      return response.data;
    }).catch(function (error) {
      return _onError(error);
    }).finally(function () {
      _guardCallback(onFinallyCallback);
    });
  },
  put: function put(url, payload, onBeginCallback, onFinallyCallback) {
    _guardCallback(onBeginCallback);

    return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.put(url, payload).then(function (response) {
      return response.data;
    }).catch(function (error) {
      return _onError(error);
    }).finally(function () {
      _guardCallback(onFinallyCallback);
    });
  },
  delete: function _delete(url, onBeginCallback, onFinallyCallback) {
    _guardCallback(onBeginCallback);

    return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.delete(url).then(function (response) {
      return response.data;
    }).catch(function (error) {
      return _onError(error);
    }).finally(function () {
      _guardCallback(onFinallyCallback);
    });
  },
  getWithOptions: function getWithOptions(url, option, onBeginCallback, onFinallyCallback) {
    _guardCallback(onBeginCallback);

    return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url, option).then(function (response) {
      return response.data;
    }).catch(function (error) {
      return _onError(error);
    }).finally(function () {
      _guardCallback(onFinallyCallback);
    });
  },
  postWithOptions: function postWithOptions(url, option, payload, onBeginCallback, onFinallyCallback) {
    _guardCallback(onBeginCallback);

    return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(url, payload, option).then(function (response) {
      return response.data;
    }).catch(function (error) {
      return _onError(error);
    }).finally(function () {
      _guardCallback(onFinallyCallback);
    });
  },
  putWithOptions: function putWithOptions(url, option, payload, onBeginCallback, onFinallyCallback) {
    _guardCallback(onBeginCallback);

    return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.put(url, payload, option).then(function (response) {
      return response.data;
    }).catch(function (error) {
      return _onError(error);
    }).finally(function () {
      _guardCallback(onFinallyCallback);
    });
  }
};

var asyncApi = {
  get: function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(url, onBeginCallback, onFinallyCallback) {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;

              _guardCallback(onBeginCallback);
              _context.next = 4;
              return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url);

            case 4:
              response = _context.sent;
              return _context.abrupt("return", response.data);

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](0);
              return _context.abrupt("return", _onError(_context.t0));

            case 11:
              _context.prev = 11;

              _guardCallback(onFinallyCallback);
              return _context.finish(11);

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this, [[0, 8, 11, 14]]);
    }));

    return function get(_x, _x2, _x3) {
      return _ref.apply(this, arguments);
    };
  }(),
  post: function () {
    var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(url, payload, onBeginCallback, onFinallyCallback, onErrorCallback) {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;

              _guardCallback(onBeginCallback);
              _context2.next = 4;
              return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(url, payload);

            case 4:
              response = _context2.sent;
              return _context2.abrupt("return", response.data);

            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](0);

              if (!(typeof onErrorCallback === "function")) {
                _context2.next = 12;
                break;
              }

              return _context2.abrupt("return", onErrorCallback(_context2.t0.response.data));

            case 12:
              return _context2.abrupt("return", _onError(_context2.t0));

            case 13:
              _context2.prev = 13;

              _guardCallback(onFinallyCallback);
              return _context2.finish(13);

            case 16:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this, [[0, 8, 13, 16]]);
    }));

    return function post(_x4, _x5, _x6, _x7, _x8) {
      return _ref2.apply(this, arguments);
    };
  }(),
  put: function () {
    var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(url, payload, onBeginCallback, onFinallyCallback, onErrorCallback) {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;

              _guardCallback(onBeginCallback);
              _context3.next = 4;
              return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.put(url, payload);

            case 4:
              response = _context3.sent;
              return _context3.abrupt("return", response.data);

            case 8:
              _context3.prev = 8;
              _context3.t0 = _context3["catch"](0);

              if (!(typeof onErrorCallback === "function")) {
                _context3.next = 12;
                break;
              }

              return _context3.abrupt("return", onErrorCallback(_context3.t0.response.data));

            case 12:
              return _context3.abrupt("return", _onError(_context3.t0));

            case 13:
              _context3.prev = 13;

              _guardCallback(onFinallyCallback);
              return _context3.finish(13);

            case 16:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this, [[0, 8, 13, 16]]);
    }));

    return function put(_x9, _x10, _x11, _x12, _x13) {
      return _ref3.apply(this, arguments);
    };
  }(),
  delete: function () {
    var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(url, onBeginCallback, onFinallyCallback) {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;

              _guardCallback(onBeginCallback);
              _context4.next = 4;
              return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.delete(url);

            case 4:
              response = _context4.sent;
              return _context4.abrupt("return", response.data);

            case 8:
              _context4.prev = 8;
              _context4.t0 = _context4["catch"](0);
              return _context4.abrupt("return", _onError(_context4.t0));

            case 11:
              _context4.prev = 11;

              _guardCallback(onFinallyCallback);
              return _context4.finish(11);

            case 14:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, _this, [[0, 8, 11, 14]]);
    }));

    return function _delete(_x14, _x15, _x16) {
      return _ref4.apply(this, arguments);
    };
  }(),
  getWithOptions: function () {
    var _ref5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(url, option, onBeginCallback, onFinallyCallback) {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;

              _guardCallback(onBeginCallback);
              _context5.next = 4;
              return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url, option);

            case 4:
              response = _context5.sent;
              return _context5.abrupt("return", response.data);

            case 8:
              _context5.prev = 8;
              _context5.t0 = _context5["catch"](0);
              return _context5.abrupt("return", _onError(_context5.t0));

            case 11:
              _context5.prev = 11;

              _guardCallback(onFinallyCallback);
              return _context5.finish(11);

            case 14:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, _this, [[0, 8, 11, 14]]);
    }));

    return function getWithOptions(_x17, _x18, _x19, _x20) {
      return _ref5.apply(this, arguments);
    };
  }(),
  postWithOptions: function () {
    var _ref6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(url, option, payload, onBeginCallback, onFinallyCallback) {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.prev = 0;

              _guardCallback(onBeginCallback);
              _context6.next = 4;
              return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(url, payload, option);

            case 4:
              response = _context6.sent;
              return _context6.abrupt("return", response.data);

            case 8:
              _context6.prev = 8;
              _context6.t0 = _context6["catch"](0);
              return _context6.abrupt("return", _onError(_context6.t0));

            case 11:
              _context6.prev = 11;

              _guardCallback(onFinallyCallback);
              return _context6.finish(11);

            case 14:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, _this, [[0, 8, 11, 14]]);
    }));

    return function postWithOptions(_x21, _x22, _x23, _x24, _x25) {
      return _ref6.apply(this, arguments);
    };
  }(),
  putWithOptions: function () {
    var _ref7 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(url, option, payload, onBeginCallback, onFinallyCallback) {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.prev = 0;

              _guardCallback(onBeginCallback);
              _context7.next = 4;
              return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.put(url, payload, option);

            case 4:
              response = _context7.sent;
              return _context7.abrupt("return", response.data);

            case 8:
              _context7.prev = 8;
              _context7.t0 = _context7["catch"](0);
              return _context7.abrupt("return", _onError(_context7.t0));

            case 11:
              _context7.prev = 11;

              _guardCallback(onFinallyCallback);
              return _context7.finish(11);

            case 14:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, _this, [[0, 8, 11, 14]]);
    }));

    return function putWithOptions(_x26, _x27, _x28, _x29, _x30) {
      return _ref7.apply(this, arguments);
    };
  }()
};



/***/ }),

/***/ 510:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isIterable2 = __webpack_require__(242);

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__(495);

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/***/ }),

/***/ 511:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(512), __esModule: true };

/***/ }),

/***/ 512:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(513);
module.exports = __webpack_require__(1).Object.entries;


/***/ }),

/***/ 513:
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(5);
var $entries = __webpack_require__(514)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),

/***/ 514:
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(6);
var getKeys = __webpack_require__(19);
var toIObject = __webpack_require__(10);
var isEnum = __webpack_require__(27).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};


/***/ }),

/***/ 532:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);



var endpoint = "https://prod-gateway-opsicar.idteknologia.net" + '/api/master/countryPhones';

/* harmony default export */ __webpack_exports__["a"] = ({
  getAll: function getAll() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + '/list').then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context.abrupt('return', _context.sent);

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),

/***/ 536:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);



var _canvas = void 0;
var _marker = void 0;
var _markers = [];
var _circle = void 0;
var _infoWindow = void 0;
var _hasAutocomplete = false;
var _hasMarker = false;
var _hasInfoWindow = false;
var _hasConfirmLocationCallback = false;
var _hasRemoveLocationCallback = false;
var _hasDrawGeometryCallback = false;
var _hasAutoCompleteGetPlaceCallback = false;
var _hasMarkerChangeCallback = false;
var _confirmLocationClassName = "save-location";
var _removeLocationClassName = "remove-location";
var _drawGeometryLocationClassName = "draw-geometry";

function _isEmpty(obj) {
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) return false;
  }
  return true;
}

function _onClickCanvas(latLng) {
  _marker.setPosition(latLng);
  _marker.setVisible(true);
}

function _onPlaceChangedAutoComplete(autocomplete) {
  // hide marker
  if (_hasMarker) {
    _marker.setVisible(false);
  }

  var place = autocomplete.getPlace();
  if (!place.geometry) {
    // User entered the name of a Place that was not suggested and
    // pressed the Enter key, or the Place Details request failed.
    window.alert("No details available for input: '" + place.name + "'");
    return;
  }

  // If the place has a geometry, then present it on a map.
  if (place.geometry.viewport) {
    _canvas.fitBounds(place.geometry.viewport);
  } else {
    _canvas.setCenter(place.geometry.location);
  }

  _canvas.setZoom(15);

  // display marker
  if (_hasMarker) {
    _marker.setPosition(place.geometry.location);
    _marker.setVisible(true);
  }

  return place;
}

function _removeCircle() {
  if (_circle !== undefined) {
    _circle.setMap(null);
  }
}

function _removeInfoWindow() {
  if (_infoWindow !== undefined) {
    _infoWindow.close();
  }
}

function _initializeCircle(coordinate, visibleCircle) {
  // remove existing objects
  _removeCircle();
  _removeInfoWindow();

  // draw circle
  _circle = new google.maps.Circle({
    center: {
      lat: coordinate.lat,
      lng: coordinate.lng
    },
    radius: coordinate.rad,
    editable: true,
    draggable: true
  });

  // fill on canvas
  if (visibleCircle) {
    var showInfoWindow = function showInfoWindow() {
      var content = "Latitude: " + _circle.getCenter().lat() + "<br>" + "Longitude: " + _circle.getCenter().lng() + "<br>" + "Radius: " + _circle.getRadius().toString();

      // Set the info window's content and position.
      _infoWindow.setContent(content);
      _infoWindow.setPosition(_circle.getBounds().getNorthEast());
      _infoWindow.open(_canvas);
    };

    // attach listener


    _circle.setMap(_canvas);

    // create window
    _infoWindow = new google.maps.InfoWindow();

    _circle.addListener("radius_changed", showInfoWindow);
    _circle.addListener("center_changed", showInfoWindow);
  }
}

var MaverickMap = function () {
  function MaverickMap(config) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, MaverickMap);

    // mapId: string
    // lat: double
    // lng: double
    // autocomplete: bool
    // marker: bool
    // infoWindow: bool
    // confirmLocationCallback: callback
    // removeLocationCallback: callback
    // drawGeometryCallback: callback
    // autoCompleteGetPlaceCallback: callback
    // markerChangeCallback: callback
    // confirmLocationClassName: string
    // removeLocationClassName: string
    // drawGeometryLocationClassName: string
    this.config = config;
    this.enableMarkerClick = config.enableMarkerClick !== false;

    _hasAutocomplete = config.autocomplete !== undefined && config.autocomplete === true;
    _hasMarker = config.marker !== undefined && config.marker === true;
    _hasInfoWindow = config.infoWindow !== undefined && config.infoWindow === true;
    _hasConfirmLocationCallback = config.confirmLocationCallback !== undefined;
    _hasRemoveLocationCallback = config.removeLocationCallback !== undefined;
    _hasDrawGeometryCallback = config.drawGeometryCallback !== undefined;
    _hasAutoCompleteGetPlaceCallback = config.autoCompleteGetPlaceCallback !== undefined;
    _hasMarkerChangeCallback = config.markerChangeCallback !== undefined;
    _confirmLocationClassName = config.confirmLocationClassName !== config.confirmLocationClassName ? config.confirmLocationClassName : _confirmLocationClassName;
    _removeLocationClassName = config.removeLocationClassName !== config.removeLocationClassName ? config.removeLocationClassName : _removeLocationClassName;
    _drawGeometryLocationClassName = config.drawGeometryLocationClassName !== config.drawGeometryLocationClassName ? config.drawGeometryLocationClassName : _drawGeometryLocationClassName;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(MaverickMap, [{
    key: "initialize",
    value: function initialize() {
      var _this = this;

      // reset
      _canvas = undefined;
      _marker = undefined;
      _circle = undefined;
      _infoWindow = undefined;

      if (_isEmpty(this.config)) {
        return;
      }

      _canvas = new google.maps.Map(document.getElementById(this.config.mapId), {
        center: {
          lat: this.config.lat,
          lng: this.config.lng
        },
        zoom: 15,
        mapTypeControl: false,
        streetViewControl: false,
        fullscreenControl: false
      });

      _canvas.addListener("bounds_changed", function () {
        var container = document.getElementsByClassName("pac-container")[0];
        if (container !== undefined && container !== null) {
          container.setAttribute("style", "z-index: 2000;");
        }
      });

      // Marker
      if (_hasMarker) {
        _marker = new google.maps.Marker({
          map: _canvas,
          anchorPoint: new google.maps.Point(0, -29)
        });

        // attach event listener
        if (this.enableMarkerClick) {
          _canvas.addListener("click", function (e) {
            var latLng = e.latLng;
            _onClickCanvas(latLng);
            if (_hasMarkerChangeCallback) {
              _this.config.markerChangeCallback({
                lat: latLng.lat(),
                lng: latLng.lng()
              });
            }
          });
        }
      }

      // Autocomplete
      if (_hasAutocomplete) {
        _canvas.controls[google.maps.ControlPosition.TOP_LEFT].push(document.getElementById("pac-card"));

        var autocomplete = new google.maps.places.Autocomplete(document.getElementById("pac-input"));

        // Bind the map's bounds (viewport) property to the autocomplete object,
        // so that the autocomplete requests use the current map bounds for the
        // bounds option in the request.
        autocomplete.bindTo("bounds", _canvas);

        // Set the data fields to return when the user selects a place.
        autocomplete.setFields(["address_components", "formatted_address", "geometry", "name", "place_id"]);

        // attach event listener
        autocomplete.addListener("place_changed", function (_) {
          var place = _onPlaceChangedAutoComplete(autocomplete);
          if (_hasAutoCompleteGetPlaceCallback) {
            _this.config.autoCompleteGetPlaceCallback(place);
          }
        });
      }

      var customControl = document.getElementById("gmap-custom-control");
      if (customControl) {
        // EventHandler: Save Location
        var saveLocationControl = customControl.getElementsByClassName(_confirmLocationClassName);
        if (_hasConfirmLocationCallback && saveLocationControl.length > 0) {
          saveLocationControl[0].addEventListener("click", function () {
            var coordinate = {};
            if (_marker !== undefined) {
              coordinate.lat = _marker.getPosition().lat();
              coordinate.lng = _marker.getPosition().lng();
            } else if (_circle !== undefined) {
              coordinate.lat = _circle.getCenter().lat();
              coordinate.lng = _circle.getCenter().lng();
              coordinate.rad = _circle.getRadius();
            }

            // callback
            _this.config.confirmLocationCallback(coordinate);
          });
        }

        // EventHandler: Remove Location
        var removeLocationControl = customControl.getElementsByClassName(_removeLocationClassName);
        if (_hasRemoveLocationCallback && removeLocationControl.length > 0) {
          removeLocationControl[0].addEventListener("click", function () {
            // remove objects
            _this.hideMarker();
            _removeCircle();
            _removeInfoWindow();

            // callback
            _this.config.removeLocationCallback();
          });
        }

        // EventHandler: Draw Geometry
        var drawGeometryControl = customControl.getElementsByClassName(_drawGeometryLocationClassName);
        if (_hasDrawGeometryCallback && drawGeometryControl.length > 0) {
          drawGeometryControl[0].addEventListener("click", function () {
            _initializeCircle({
              lat: _canvas.getCenter().lat(),
              lng: _canvas.getCenter().lng(),
              rad: 700
            }, true);
          });
        }
      }
    }
  }, {
    key: "showInfoWindow",
    value: function showInfoWindow(position, content) {
      if (_hasInfoWindow) {
        // initialize if empty
        if (_infoWindow === undefined) {
          _infoWindow = new google.maps.InfoWindow();
        }

        var latLng = new google.maps.LatLng(position.latitude, position.longitude);

        // Set the info window's content and position.
        _infoWindow.setContent(content);
        _infoWindow.setPosition(latLng);
        _infoWindow.open(_canvas);

        _canvas.setCenter(latLng);
        _canvas.setZoom(20);
      }
    }
  }, {
    key: "showMarker",
    value: function showMarker(center) {
      var iconUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      // if (_hasMarker) {
      //   _marker.setPosition(center);
      //   _marker.setVisible(true);
      // }

      if (_hasMarker) {
        // Hapus marker lama jika ada
        if (_marker) {
          _marker.setMap(null);
        }

        // Buat marker baru
        var markerOptions = {
          position: center,
          map: _canvas
        };

        if (iconUrl) {
          markerOptions.icon = {
            url: iconUrl
          };
        }

        _marker = new google.maps.Marker(markerOptions);
        _marker.setVisible(true);
      }
      _canvas.setCenter(center);
      _canvas.setZoom(15);
    }
  }, {
    key: "hideMarker",
    value: function hideMarker() {
      if (_hasMarker) {
        _marker.setVisible(false);
      }
      _canvas.setZoom(15);
    }
  }, {
    key: "setCircleCenter",
    value: function setCircleCenter(center, radius, visibleCircle) {
      if (_circle === undefined) {
        _initializeCircle({
          lat: center.lat(),
          lng: center.lng(),
          rad: radius
        }, visibleCircle);
      } else {
        _circle.setCenter(center);
        _circle.setRadius(radius);
      }
      _canvas.fitBounds(_circle.getBounds());
      _canvas.setZoom(12);
    }
  }, {
    key: "addMarker",
    value: function addMarker(_ref) {
      var lat = _ref.lat,
          lng = _ref.lng,
          icon = _ref.icon;
      var infoContent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      var marker = new google.maps.Marker({
        position: { lat: lat, lng: lng },
        map: _canvas,
        anchorPoint: new google.maps.Point(0, -29),
        icon: {
          url: icon ? icon : "/static/assets/images/dot-marker.svg",
          scaledSize: new google.maps.Size(35, 35)
        }
      });
      _markers.push(marker);

      if (infoContent) {
        var infoWindow = new google.maps.InfoWindow({
          content: infoContent
        });

        var isOpen = true;

        infoWindow.open(_canvas, marker);

        marker.addListener("click", function () {
          if (isOpen) {
            infoWindow.close();
          } else {
            infoWindow.open(_canvas, marker);
          }
          isOpen = !isOpen;
        });
      }
    }
  }, {
    key: "clearMarkers",
    value: function clearMarkers() {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(_markers), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var m = _step.value;

          m.setMap(null);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      _markers = [];
    }
  }, {
    key: "fitToMarkers",
    value: function fitToMarkers() {
      if (_markers.length === 0) return;
      var bounds = new google.maps.LatLngBounds();
      _markers.forEach(function (marker) {
        return bounds.extend(marker.getPosition());
      });
      _canvas.fitBounds(bounds);
    }
  }, {
    key: "setCenter",
    value: function setCenter(_ref2) {
      var lat = _ref2.lat,
          lng = _ref2.lng;
      var zoom = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      if (_canvas) {
        var centerLatLng = new google.maps.LatLng(lat, lng);
        _canvas.setCenter(centerLatLng);

        if (zoom !== null) {
          _canvas.setZoom(zoom);
        }
      }
    }
  }, {
    key: "setZoom",
    value: function setZoom() {
      var zoom = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (_canvas) {
        if (zoom !== null) {
          _canvas.setZoom(zoom);
        }
      }
    }
  }, {
    key: "isInRadius",
    get: function get() {
      var result = false;
      if (_circle !== undefined) {
        result = google.maps.geometry.spherical.computeDistanceBetween(_marker.getPosition(), _circle.getCenter()) <= _circle.getRadius();
        if (!result) {
          _marker.setVisible(false);
        }
      }
      return result;
    }
  }]);

  return MaverickMap;
}();

/* harmony default export */ __webpack_exports__["a"] = (MaverickMap);

/***/ }),

/***/ 562:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_apiService__ = __webpack_require__(500);




var endpoint = "https://prod-gateway-opsicar.idteknologia.net" + '/api/master/providers';

/* harmony default export */ __webpack_exports__["a"] = ({
  getAll: function getAll(filter) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + ('/list' + filter)).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context.abrupt('return', _context.sent);

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  getAllActive: function getAllActive() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + '/list/active').then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context2.abrupt('return', _context2.sent);

            case 3:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  getAllActiveWoSubscriber: function getAllActiveWoSubscriber() {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + '/list/activewosubscriber').then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context3.abrupt('return', _context3.sent);

            case 3:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  getMasterOperators: function getMasterOperators(onBeginCallback, onFinallyCallback) {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt('return', __WEBPACK_IMPORTED_MODULE_3__services_apiService__["a" /* asyncApi */].get(endpoint + '/list/master-operator', onBeginCallback, onFinallyCallback));

            case 1:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  create: function create(request) {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint, request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context5.abrupt('return', _context5.sent);

            case 3:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  },
  update: function update(request) {
    var _this6 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(endpoint, request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context6.abrupt('return', _context6.sent);

            case 3:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this6);
    }))();
  },
  delete: function _delete(id) {
    var _this7 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.delete(endpoint + ('/' + id)).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context7.abrupt('return', _context7.sent);

            case 3:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, _this7);
    }))();
  },
  uploadImage: function uploadImage(request) {
    var _this8 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint + '/image', request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context8.abrupt('return', _context8.sent);

            case 3:
            case 'end':
              return _context8.stop();
          }
        }
      }, _callee8, _this8);
    }))();
  }
});

/***/ }),

/***/ 618:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);



var _geocoder = void 0;

var MaverickGeocoding = function () {
  function MaverickGeocoding() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, MaverickGeocoding);

    _geocoder = new google.maps.Geocoder();
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(MaverickGeocoding, [{
    key: 'geocode',
    value: function geocode(latLng) {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _geocoder.geocode({
          location: latLng
        }, function (results, status) {
          if (status === "OK") {
            var result = results[0];
            var address = result.formatted_address;
            var name = '';
            if (result.address_components !== undefined && result.address_components !== null && result.address_components.length > 0) {
              var administrative_area_level_4 = '';
              var administrative_area_level_3 = '';
              var administrative_area_level_2 = '';
              var administrative_area_level_1 = '';
              var country = '';
              for (var index = 0; index < result.address_components.length; index++) {
                var addressComponent = result.address_components[index];
                if (addressComponent.types.includes('administrative_area_level_4')) {
                  administrative_area_level_4 = addressComponent.long_name;
                } else if (addressComponent.types.includes('administrative_area_level_3')) {
                  administrative_area_level_3 = addressComponent.long_name;
                } else if (addressComponent.types.includes('administrative_area_level_2')) {
                  administrative_area_level_2 = addressComponent.long_name;
                } else if (addressComponent.types.includes('administrative_area_level_1')) {
                  administrative_area_level_1 = addressComponent.long_name;
                } else if (addressComponent.types.includes('country')) {
                  country = addressComponent.long_name;
                }
              }
              if (administrative_area_level_4 !== '') {
                name = administrative_area_level_4;
              } else if (administrative_area_level_3 !== '') {
                name = administrative_area_level_3;
              } else if (administrative_area_level_2 !== '') {
                name = administrative_area_level_2;
              } else {
                name = address.split(',')[0];
              }

              // append city and country
              if (administrative_area_level_1 !== '' && country !== '') {
                name += ', ' + administrative_area_level_1 + ', ' + country;
              }
            }
            resolve({
              address: address,
              name: name,
              latitude: latLng.lat,
              longitude: latLng.lng
            });
          } else {
            reject();
          }
        });
      });
    }
  }]);

  return MaverickGeocoding;
}();

/* harmony default export */ __webpack_exports__["a"] = (MaverickGeocoding);

/***/ }),

/***/ 677:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);



var endpoint = "https://prod-gateway-opsicar.idteknologia.net" + "/api/master/termscondition";

/* harmony default export */ __webpack_exports__["a"] = ({
  getAll: function getAll() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context.abrupt("return", _context.sent);

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  getById: function getById(id) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + ("/" + id)).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context2.abrupt("return", _context2.sent);

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  saveToDraft: function saveToDraft(request) {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint + "/draft", request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context3.abrupt("return", _context3.sent);

            case 3:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  publish: function publish(request) {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint + "/publish", request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context4.abrupt("return", _context4.sent);

            case 3:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  }
});

/***/ }),

/***/ 738:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_shared_DeleteModal__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_master_provider_ProviderDocument__ = __webpack_require__(921);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__services_master_provider_providerService_js__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__services_master_regionFormatService_js__ = __webpack_require__(924);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__services_master_countryPhoneService_js__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__services_master_termsCondition_termsConditionService_js__ = __webpack_require__(677);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__services_master_operatingCityService__ = __webpack_require__(925);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__plugins_google_map_js__ = __webpack_require__(536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__plugins_google_geocode_js__ = __webpack_require__(618);







//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    deleteModal: __WEBPACK_IMPORTED_MODULE_9__components_shared_DeleteModal__["a" /* default */],
    providerDocumentComponent: __WEBPACK_IMPORTED_MODULE_10__components_master_provider_ProviderDocument__["a" /* default */]
  },
  computed: {
    isAllowToRead: function isAllowToRead() {
      return this.allServices && this.allServices["Provider"] && this.allServices["Provider"].includes("Read");
    },
    isAllowToCreate: function isAllowToCreate() {
      return this.allServices && this.allServices["Provider"] && this.allServices["Provider"].includes("Create");
    },
    isAllowToUpdate: function isAllowToUpdate() {
      return this.allServices && this.allServices["Provider"] && this.allServices["Provider"].includes("Update");
    },
    isAllowToDelete: function isAllowToDelete() {
      return this.allServices && this.allServices["Provider"] && this.allServices["Provider"].includes("Delete");
    },
    recordInfo: function recordInfo() {
      return this.table.totalRecords > 1 ? this.table.totalRecords + " Records" : this.table.totalRecords + " Record";
    },
    validationRuleSalesTaxNo: function validationRuleSalesTaxNo() {
      return this.model.isSalesTaxApplicable ? { required: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["required"], maxLength: Object(__WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["maxLength"])(100) } : { maxLength: Object(__WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["maxLength"])(100) };
    },
    validationRuleBankConfig: function validationRuleBankConfig() {
      return this.model.paymentMethod === "BankTransfer" ? {
        accountOwner: { required: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["required"], maxLength: Object(__WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["maxLength"])(150) },
        accountNumber: { required: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["required"], maxLength: Object(__WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["maxLength"])(100) },
        internationalAccountNumber: { maxLength: Object(__WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["maxLength"])(100) },
        swift: { maxLength: Object(__WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["maxLength"])(100) }
      } : {
        accountOwner: { maxLength: Object(__WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["maxLength"])(150) },
        accountNumber: { maxLength: Object(__WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["maxLength"])(100) },
        internationalAccountNumber: { maxLength: Object(__WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["maxLength"])(100) },
        swift: { maxLength: Object(__WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["maxLength"])(100) }
      };
    },
    validationRulePayPalConfig: function validationRulePayPalConfig() {
      return this.model.paymentMethod === "PayPal" ? { email: { required: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["required"], email: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["email"], maxLength: Object(__WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["maxLength"])(100) } } : { email: { email: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["email"], maxLength: Object(__WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["maxLength"])(100) } };
    },
    validationRuleContactPeople: function validationRuleContactPeople() {
      return this.model.contactPeople && this.model.contactPeople.length > 0 ? {
        $each: {
          title: { required: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["required"] },
          otherTitle: {},
          fullName: { required: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["required"], maxLength: Object(__WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["maxLength"])(150) },
          email: { email: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["email"], required: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["required"], maxLength: Object(__WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["maxLength"])(100) },
          alternateEmail: { email: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["email"], maxLength: Object(__WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["maxLength"])(100) },
          phoneCode: { required: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["required"] },
          phoneNumber: { required: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["required"], maxLength: Object(__WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["maxLength"])(20) },
          alternatePhoneNumber: { maxLength: Object(__WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["maxLength"])(20) },
          jobTitle: { maxLength: Object(__WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["maxLength"])(50) }
        }
      } : {
        $each: {
          title: {},
          otherTitle: {},
          fullName: { maxLength: Object(__WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["maxLength"])(150) },
          email: { email: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["email"], maxLength: Object(__WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["maxLength"])(100) },
          alternateEmail: { email: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["email"], maxLength: Object(__WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["maxLength"])(100) },
          phoneCode: {},
          phoneNumber: { maxLength: Object(__WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["maxLength"])(20) },
          alternatePhoneNumber: { maxLength: Object(__WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["maxLength"])(20) },
          jobTitle: { maxLength: Object(__WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["maxLength"])(50) }
        }
      };
    },
    sanitizePhoneNumber: {
      get: function get() {
        return this.model.phoneNumber;
      },
      set: function set(value) {
        this.model.phoneNumber = value.replace(/\D/g, "");
      }
    },
    sanitizeAltPhoneNumber: {
      get: function get() {
        return this.model.alternatePhoneNumber;
      },
      set: function set(value) {
        this.model.alternatePhoneNumber = value.replace(/\D/g, "");
      }
    }
  },
  data: function data() {
    return {
      table: {
        keyword: "",
        totalPages: 1,
        totalRecords: 0,
        pageNumber: 1,
        pageSize: 25,
        pageSizes: [25, 50, 100],
        sort: "",
        sortDir: ""
      },
      isSubmitted: false,
      activeTab: "general",
      publicSettings: [],
      rentalLabel: null,
      airportLabel: null,
      airportAlgorithm: null,
      allServices: null,
      map: null,
      geocoder: null,
      isViewOnly: false,
      deleteId: null,
      deleteOption: null,
      imagePreview: null,
      imageData: null,
      termsConditions: {
        id: null,
        title: null,
        deadlineDate: null,
        content: "",
        createdDate: null,
        modifiedDate: null
      },
      items: [],
      titles: [],
      phoneCodes: [],
      regionFormats: [],
      operatingCities: [],
      selection: {
        operatingCities: [],
        masterOperators: []
      },
      model: {},
      defaultValueAgreement: true,
      location: { name: null, address: null, latitude: null, longitude: null },
      isLoading: false,
      isUpdate: false,
      userType: null,
      msg: "Please wait"
    };
  },
  validations: function validations() {
    return {
      model: {
        name: { required: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["required"], maxLength: Object(__WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["maxLength"])(100) },
        email: { required: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["required"], email: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["email"], maxLength: Object(__WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["maxLength"])(150) },
        alternateEmail: { email: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["email"], maxLength: Object(__WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["maxLength"])(150) },
        city: { required: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["required"], maxLength: Object(__WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["maxLength"])(100) },
        phoneCode: { required: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["required"] },
        phoneNumber: { required: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["required"], maxLength: Object(__WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["maxLength"])(20) },
        alternatePhoneNumber: { maxLength: Object(__WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["maxLength"])(20) },
        regionFormatId: { required: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["required"] },
        salesTaxNumber: this.validationRuleSalesTaxNo,
        bankConfiguration: this.validationRuleBankConfig,
        paypalConfiguration: this.validationRulePayPalConfig,
        contactPeople: this.validationRuleContactPeople,
        operatingCities: { required: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["required"] }
      },
      location: { address: { required: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["required"] } }
    };
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee() {
      var profile;
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.$helper.scrollTop();
              _context.next = 3;
              return _this.$store.dispatch("setting/getAllPublic");

            case 3:
              _this.publicSettings = _context.sent;

              // this.getTermsAndConditions();
              _this.table.pageSize = _this.$helper.extractSetting(_this.publicSettings, "PageSize", 25);
              _this.rentalLabel = _this.$helper.extractSetting(_this.publicSettings, "RentalLabel", "Hourly");
              _this.airportLabel = _this.$helper.extractSetting(_this.publicSettings, "AirportLabel", "Airport");
              _this.airportAlgorithm = _this.$helper.extractSetting(_this.publicSettings, "AirportAlgorithm", "Distance");

              _context.next = 10;
              return _this.$store.dispatch("user/getProfile");

            case 10:
              profile = _context.sent;

              _this.userType = profile.userType;

              _this.allServices = profile.services;

              if (!_this.isAllowToRead) {
                _context.next = 22;
                break;
              }

              _context.next = 16;
              return _this.getAll();

            case 16:
              _context.next = 18;
              return _this.getPhoneCodes();

            case 18:
              _context.next = 20;
              return _this.getRegionFormats();

            case 20:
              _context.next = 22;
              return _this.fetchOperatingCities();

            case 22:
              _this.titles = [{ value: "Mr", text: "Mr" }, { value: "Mrs", text: "Mrs" }, { value: "Ms", text: "Ms" }, { value: "Other", text: "Others" }];

            case 23:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  mounted: function mounted() {
    $(this.$refs.providermodal).on("hidden.bs.modal", this.closeModal);
    $(this.$refs.mapmodal).on("hidden.bs.modal", this.closeMapModal);

    if (!this.map) {
      var defaultLatLng = this.$helper.extractSetting(this.publicSettings, "DefaultLatLng", "-6.17003832454938|106.81490242481232");
      var latLng = defaultLatLng.split("|");
      var lat = parseFloat(latLng[0]);
      var lng = parseFloat(latLng[1]);

      // creates map instance
      this.map = new __WEBPACK_IMPORTED_MODULE_16__plugins_google_map_js__["a" /* default */]({
        mapId: "map",
        lat: lat,
        lng: lng,
        marker: true,
        autocomplete: true,
        confirmLocationCallback: this.confirmLocation,
        removeLocationCallback: this.removeLocation,
        autoCompleteGetPlaceCallback: this.getPlace,
        markerChangeCallback: this.markerChange
      });
      this.map.initialize();
    }

    if (!this.geocoder) {
      // creates geocoder instance
      this.geocoder = new __WEBPACK_IMPORTED_MODULE_17__plugins_google_geocode_js__["a" /* default */]();
    }
  },
  updated: function updated() {
    // subscribe event
    this.$eventBus.$on("openProviderDeleteModal", this.openDeleteModal);
    this.$helper.collapseMenu("fleet-master");
    this.$helper.setNavigationClass("provider-link");
    this.$helper.alphabetsOnly();
    this.$helper.alphabetsCharactersOnly();
    this.$helper.numbersOnly();
    this.$helper.disableContextMenu(".readonly");
  },
  beforeDestroy: function beforeDestroy() {
    // unsubscribe event
    this.$eventBus.$off("openProviderDeleteModal");
    document.querySelectorAll(".pac-container").forEach(function (element) {
      return element.remove();
    });
  },

  methods: {
    startLoader: function startLoader() {
      this.isLoading = true;
    },
    stopLoader: function stopLoader() {
      this.isLoading = false;
    },
    getTermsAndConditions: function getTermsAndConditions() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var response, index;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_14__services_master_termsCondition_termsConditionService_js__["a" /* default */].getAll();

              case 3:
                response = _context2.sent;


                if (response.isSuccess) {
                  _this2.termsConditions = response.data.latest;
                }
                _context2.next = 10;
                break;

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2["catch"](0);

                if (_context2.t0.errors) {
                  for (index = 0; index < _context2.t0.errors.length; index++) {
                    _this2.$notification.error(_context2.t0.errors[index], { title: "Error" });
                  }
                }

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 7]]);
      }))();
    },
    onPreview: function onPreview() {
      $(this.$refs.previewModal).modal({
        backdrop: "static",
        keyboard: false
      });
    },
    closePreviewModal: function closePreviewModal() {
      $(this.$refs.previewModal).modal("hide");
      setTimeout(function () {
        $("body").addClass("modal-open");
      }, 500);
    },
    onChangePageSize: function onChangePageSize() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.table.pageNumber = 1;
                _context3.next = 3;
                return _this3.getAll();

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    onKeyupKeyword: function onKeyupKeyword() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var self;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                self = _this4;

                if (self.timer) {
                  clearTimeout(self.timer);
                  self.timer = null;
                }
                self.timer = setTimeout(function () {
                  var _ref = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee4(_) {
                    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                      while (1) {
                        switch (_context4.prev = _context4.next) {
                          case 0:
                            self.table.pageNumber = 1;
                            _context4.next = 3;
                            return self.getAll();

                          case 3:
                          case "end":
                            return _context4.stop();
                        }
                      }
                    }, _callee4, _this4);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }(), 500);

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this4);
      }))();
    },
    onNavigateCallback: function onNavigateCallback(pageNumber) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee6() {
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _this5.table.pageNumber = pageNumber;
                _context6.next = 3;
                return _this5.getAll();

              case 3:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this5);
      }))();
    },
    onClickSort: function onClickSort(column) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee7() {
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (_this6.table.sort === column) {
                  _this6.table.sortDir = _this6.table.sortDir === "asc" ? "desc" : "asc";
                } else {
                  _this6.table.sortDir = "asc";
                }
                _this6.table.sort = column;
                _context7.next = 4;
                return _this6.getAll();

              case 4:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, _this6);
      }))();
    },
    confirmLocation: function confirmLocation(coordinate) {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee8() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if (!_this7.isMarkerChange) {
                  _context8.next = 5;
                  break;
                }

                _context8.next = 3;
                return _this7.geocoder.geocode(coordinate);

              case 3:
                response = _context8.sent;

                if (response) {
                  _this7.location.address = response.address;
                  _this7.location.name = response.name;
                  _this7.location.latitude = response.latitude;
                  _this7.location.longitude = response.longitude;
                }

              case 5:
                _this7.$notification.success("Location saved.", { title: "Success" });
                _this7.closeMapModal();

              case 7:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, _this7);
      }))();
    },
    removeLocation: function removeLocation() {
      document.getElementById("pac-input").value = "";
      this.isMarkerChange = false;
      this.location = {
        name: null,
        address: null,
        latitude: null,
        longitude: null
      };
      this.$notification.success("Location removed.", { title: "Success" });
    },
    getPlace: function getPlace(place) {
      // get place from autocomplete
      this.isMarkerChange = false;
      this.location.name = place.name;
      this.location.address = place.formatted_address;
      this.location.latitude = place.geometry.location.lat();
      this.location.longitude = place.geometry.location.lng();
    },
    markerChange: function markerChange(latLng) {
      this.isMarkerChange = true;
    },
    getAll: function getAll() {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee9() {
        var filter, response, index;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                if (_this8.isAllowToRead) {
                  _context9.next = 2;
                  break;
                }

                return _context9.abrupt("return");

              case 2:
                _context9.prev = 2;

                _this8.isLoading = true;
                filter = "?page=" + _this8.table.pageNumber + "&size=" + _this8.table.pageSize;

                if (_this8.table.keyword && _this8.table.keyword !== "") {
                  filter += "&search=" + _this8.table.keyword;
                }
                if (_this8.table.sort && _this8.table.sort !== "") {
                  filter += "&sort=" + _this8.table.sort + "&sortDir=" + _this8.table.sortDir;
                }
                _context9.next = 9;
                return __WEBPACK_IMPORTED_MODULE_11__services_master_provider_providerService_js__["a" /* default */].getAll(filter);

              case 9:
                response = _context9.sent;

                _this8.items = response.data;
                _this8.table.totalPages = response.totalPages;
                _this8.table.totalRecords = response.totalRecords;
                _context9.next = 18;
                break;

              case 15:
                _context9.prev = 15;
                _context9.t0 = _context9["catch"](2);

                if (_context9.t0.errors) {
                  for (index = 0; index < _context9.t0.errors.length; index++) {
                    _this8.$notification.error(_context9.t0.errors[index], { title: "Error" });
                  }
                }

              case 18:
                _context9.prev = 18;

                _this8.isLoading = false;
                return _context9.finish(18);

              case 21:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, _this8, [[2, 15, 18, 21]]);
      }))();
    },
    getRegionFormats: function getRegionFormats() {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee10() {
        var i, regionFormat, timezone;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return __WEBPACK_IMPORTED_MODULE_12__services_master_regionFormatService_js__["a" /* default */].getAll();

              case 2:
                _this9.regionFormats = _context10.sent;


                for (i = 0; i < _this9.regionFormats.length; i++) {
                  regionFormat = _this9.regionFormats[i];
                  timezone = regionFormat.timeZone > 0 ? "+" + regionFormat.timeZone : regionFormat.timeZone;

                  regionFormat.label = regionFormat.title + " / " + regionFormat.cultureCode + " / UTC " + timezone;
                }

              case 4:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, _this9);
      }))();
    },
    getPhoneCodes: function getPhoneCodes() {
      var _this10 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee11() {
        var i, item;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return __WEBPACK_IMPORTED_MODULE_13__services_master_countryPhoneService_js__["a" /* default */].getAll();

              case 2:
                _this10.phoneCodes = _context11.sent;


                for (i = 0; i < _this10.phoneCodes.length; i++) {
                  item = _this10.phoneCodes[i];

                  item.label = item.iata + " (+" + item.dial + ")";
                  item.icon = "iti-flag " + item.iata.toLowerCase();
                }

              case 4:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, _this10);
      }))();
    },
    fetchOperatingCities: function fetchOperatingCities() {
      var _this11 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee12() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.next = 2;
                return __WEBPACK_IMPORTED_MODULE_15__services_master_operatingCityService__["a" /* operatingCityService */].getAllAsync(null, true);

              case 2:
                response = _context12.sent;

                _this11.operatingCities = response.isSuccess ? response.data : [];

              case 4:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, _this11);
      }))();
    },
    fetchMasterOperators: function fetchMasterOperators() {
      var _this12 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee13() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _this12.selection.masterOperators = [];
                _context13.next = 3;
                return __WEBPACK_IMPORTED_MODULE_11__services_master_provider_providerService_js__["a" /* default */].getMasterOperators(_this12.startLoader, _this12.stopLoader);

              case 3:
                response = _context13.sent;


                if (response.isSuccess) {
                  _this12.selection.masterOperators = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries___default()(response.data).map(function (_ref2) {
                    var _ref3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref2, 2),
                        key = _ref3[0],
                        value = _ref3[1];

                    return {
                      value: key,
                      text: value
                    };
                  });
                }

              case 5:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, _this12);
      }))();
    },
    resetModel: function resetModel() {
      this.isMarkerChange = false;
      this.model = {};
      this.location = {
        name: null,
        address: null,
        latitude: null,
        longitude: null
      };
    },
    resetValidations: function resetValidations() {
      this.isSubmitted = false;
      this.$v.model.$reset();
      this.$v.location.$reset();
    },
    searchPhoneCode: function searchPhoneCode(options, search) {
      var pattern = new RegExp(search.toLowerCase(), "i");
      return this.phoneCodes.filter(function (item) {
        return pattern.test(item.area) || pattern.test(item.country) || pattern.test(item.dial) || pattern.test(item.iata);
      });
    },
    openModal: function openModal(object) {
      var _this13 = this;

      this.resetValidations();
      this.model = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, object);

      if (this.isUpdate && this.model.operatingCities && this.model.operatingCities.length > 0) {
        var operatingCityCountryCodes = this.model.operatingCities.map(function (item) {
          return item.twoDigitCountryCode;
        });

        if (this.userType !== "TenantUser") {
          this.selection.operatingCities = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()([], this.operatingCities.filter(function (item) {
            return operatingCityCountryCodes.includes(item.twoDigitCountryCode) || operatingCityCountryCodes.includes(item.threeDigitCountryCode);
          }));
        } else {
          this.selection.operatingCities = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()([], this.operatingCities);
        }
      } else {
        this.selection.operatingCities = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()([], this.operatingCities);
      }

      if (this.model.location) {
        this.location = this.model.location;
      }

      this.fetchMasterOperators().then(function () {
        $(_this13.$refs.providermodal).modal({
          backdrop: "static",
          keyboard: false
        });
      });
    },
    closeModal: function closeModal() {
      var imageUploader = document.getElementById("image-uploader");
      if (imageUploader) {
        imageUploader.value = "";
      }
      this.imagePreview = null;
      this.imageData = null;
      this.resetModel();
      this.resetValidations();
      $(this.$refs.providermodal).modal("hide");
    },
    openMapModal: function openMapModal(object) {
      document.getElementById("pac-input").value = "";
      this.resetValidations();
      if (this.location && this.location.latitude !== null && this.location.longitude !== null) {
        this.map.showMarker(new google.maps.LatLng(this.location.latitude, this.location.longitude));
      } else {
        this.map.hideMarker();
      }
      $(this.$refs.mapmodal).modal({ backdrop: "static", keyboard: false });
    },
    closeMapModal: function closeMapModal() {
      $(this.$refs.mapmodal).modal("hide");
      $(this.$refs.providermodal).css("overflow-y", "auto");
    },
    createItem: function createItem() {
      var uploader = document.getElementById("image-uploader");
      if (uploader) {
        uploader.value = "";
      }
      this.isViewOnly = false;
      this.isUpdate = false;
      this.activeTab = "general";
      this.openModal({
        paymentMethod: "Unspecified",
        bankConfiguration: {},
        paypalConfiguration: {},
        contactPeople: [],
        phoneNumber: "",
        alternatePhoneNumber: ""
      });
    },
    updateItem: function updateItem(item) {
      var _this14 = this;

      this.isViewOnly = false;
      this.isUpdate = true;
      this.imagePreview = item.imageUri;
      this.activeTab = "general";
      var dataModel = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, item, {
        contactPeople: item.contactPeople.map(function (person) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, person, {
            title: _this14.findTitle(person.title, "title"),
            otherTitle: _this14.findTitle(person.title, "otherTitle")
          });
        })
      });
      this.openModal(dataModel);
    },
    findTitle: function findTitle(value, type) {
      var findTitle = this.titles.find(function (val) {
        return val.value === value;
      });

      if (type === "title") return findTitle ? value : "Other";else return findTitle ? null : value;
    },
    resetImage: function resetImage() {
      this.imageData = null;
      this.imagePreview = null;
      document.getElementById("image-uploader").value = "";
    },
    viewItem: function viewItem(item) {
      this.isViewOnly = true;
      this.isUpdate = false;
      this.imagePreview = item.imageUri;
      this.openModal(item);
    },
    constuctPayload: function constuctPayload() {
      var payload = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, this.model);

      payload.contactPeople = payload.contactPeople.map(function (person) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, person, {
          title: person.title === "Other" ? person.otherTitle : person.title
        });
      });

      payload.operatingCities = this.model.operatingCities.map(function (item) {
        return item.id;
      });

      payload.location.latitude = payload.location.latitude ? payload.location.latitude : 0;
      payload.location.longitude = payload.location.longitude ? payload.location.longitude : 0;

      return payload;
    },
    submit: function submit() {
      var _this15 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee14() {
        var payload, response, index;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _this15.isSubmitted = true;
                _this15.model.email = _this15.model.email ? _this15.model.email.toLowerCase() : "";
                _this15.model.alternateEmail = _this15.model.alternateEmail ? _this15.model.alternateEmail.toLowerCase() : "";
                _this15.$v.model.$touch();
                _this15.$v.location.$touch();

                if (!(_this15.$v.model.$error || _this15.$v.location.$error)) {
                  _context14.next = 7;
                  break;
                }

                return _context14.abrupt("return");

              case 7:
                _context14.prev = 7;

                _this15.isLoading = true;
                _this15.model.isChangeStatus = false;
                _this15.model.location = _this15.location;

                payload = _this15.constuctPayload();

                if (!_this15.isUpdate) {
                  _context14.next = 20;
                  break;
                }

                _context14.next = 15;
                return __WEBPACK_IMPORTED_MODULE_11__services_master_provider_providerService_js__["a" /* default */].update(payload);

              case 15:
                _context14.next = 17;
                return _this15.uploadImage(payload.id);

              case 17:
                _this15.$notification.success("Successfully updated.", {
                  title: "Success"
                });
                _context14.next = 26;
                break;

              case 20:
                _context14.next = 22;
                return __WEBPACK_IMPORTED_MODULE_11__services_master_provider_providerService_js__["a" /* default */].create(payload);

              case 22:
                response = _context14.sent;
                _context14.next = 25;
                return _this15.uploadImage(response.data);

              case 25:
                _this15.$notification.success("Successfully added.", {
                  title: "Success"
                });

              case 26:
                _this15.resetModel();
                _this15.closeModal();
                _context14.next = 30;
                return _this15.getAll();

              case 30:
                _context14.next = 35;
                break;

              case 32:
                _context14.prev = 32;
                _context14.t0 = _context14["catch"](7);

                if (_context14.t0.errors) {
                  for (index = 0; index < _context14.t0.errors.length; index++) {
                    _this15.$notification.error(_context14.t0.errors[index], { title: "Error" });
                  }
                }

              case 35:
                _context14.prev = 35;

                _this15.isLoading = false;
                return _context14.finish(35);

              case 38:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, _this15, [[7, 32, 35, 38]]);
      }))();
    },
    uploadImage: function uploadImage(id) {
      var _this16 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee15() {
        var uploader, _$refs$cropper$getRes, canvas, model, formData, key, blob;

        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                uploader = document.getElementById("image-uploader");

                if (!(uploader.value && uploader.value !== "")) {
                  _context15.next = 13;
                  break;
                }

                _$refs$cropper$getRes = _this16.$refs.cropper.getResult(), canvas = _$refs$cropper$getRes.canvas;

                if (!canvas) {
                  _context15.next = 13;
                  break;
                }

                model = {
                  id: id
                };
                formData = new FormData();

                for (key in model) {
                  if (model.hasOwnProperty(key)) {
                    formData.append(key, model[key]);
                  }
                }
                _context15.next = 9;
                return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
                  return canvas.toBlob(resolve);
                });

              case 9:
                blob = _context15.sent;

                formData.append("file", blob, _this16.imageData.name);
                _context15.next = 13;
                return __WEBPACK_IMPORTED_MODULE_11__services_master_provider_providerService_js__["a" /* default */].uploadImage(formData);

              case 13:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, _this16);
      }))();
    },
    changeStatus: function changeStatus(item) {
      var _this17 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee16() {
        var payload, index;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _context16.prev = 0;

                _this17.isLoading = true;
                item.isChangeStatus = true;

                payload = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, item);


                payload.operatingCities = item.operatingCities.map(function (item) {
                  return item.id;
                });

                _context16.next = 7;
                return __WEBPACK_IMPORTED_MODULE_11__services_master_provider_providerService_js__["a" /* default */].update(payload);

              case 7:
                _this17.$notification.success("Successfully updated.", {
                  title: "Success"
                });
                _context16.next = 10;
                return _this17.getAll();

              case 10:
                _this17.resetValidations();
                _context16.next = 16;
                break;

              case 13:
                _context16.prev = 13;
                _context16.t0 = _context16["catch"](0);

                if (_context16.t0.errors) {
                  for (index = 0; index < _context16.t0.errors.length; index++) {
                    _this17.$notification.error(_context16.t0.errors[index], { title: "Error" });
                  }
                }

              case 16:
                _context16.prev = 16;

                _this17.isLoading = false;
                return _context16.finish(16);

              case 19:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, _this17, [[0, 13, 16, 19]]);
      }))();
    },
    onChangeImage: function onChangeImage(files) {
      var maxSize = 4 * 1024 * 1024;
      if (files[0].size > maxSize) {
        this.imagePreview = "";
        this.imageData = null;
        document.getElementById("image-uploader").value = "";
        alert("File is too big, max-size is  " + parseInt(maxSize / 1000000) + "MB.");
        return;
      }
      if (!["jpeg", "jpg", "png"].includes(files[0].name.substring(files[0].name.lastIndexOf(".") + 1).toLowerCase())) {
        this.imagePreview = "";
        this.imageData = null;
        document.getElementById("image-uploader").value = "";
        alert("Invalid file type.");
        return;
      }
      this.imagePreview = URL.createObjectURL(files[0]);
      this.imageData = files[0];
    },
    openDeleteModal: function openDeleteModal(option, id) {
      this.deleteOption = option;
      this.deleteId = id;
      $("#deletemodal").modal();
    },
    cancelDelete: function cancelDelete() {
      switch (this.deleteOption) {
        case "providerDocument":
          // publish message
          this.$eventBus.$emit("openModalProviderDocument", this.deleteId);
          break;
      }
      this.deleteId = null;
      this.deleteOption = null;
      $("#deletemodal").modal("hide");
    },
    deleteItem: function deleteItem() {
      var _this18 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee17() {
        var index, _index;

        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                _context17.prev = 0;

                _this18.isLoading = true;
                _context17.t0 = _this18.deleteOption;
                _context17.next = _context17.t0 === "provider" ? 5 : _context17.t0 === "providerDocument" ? 17 : 19;
                break;

              case 5:
                _context17.prev = 5;
                _context17.next = 8;
                return __WEBPACK_IMPORTED_MODULE_11__services_master_provider_providerService_js__["a" /* default */].delete(_this18.deleteId);

              case 8:
                _this18.$notification.success("Successfully deleted.", {
                  title: "Success"
                });
                _context17.next = 11;
                return _this18.getAll();

              case 11:
                _context17.next = 16;
                break;

              case 13:
                _context17.prev = 13;
                _context17.t1 = _context17["catch"](5);

                if (_context17.t1.errors) {
                  for (index = 0; index < _context17.t1.errors.length; index++) {
                    _this18.$notification.error(_context17.t1.errors[index], {
                      title: "Error"
                    });
                  }
                }

              case 16:
                return _context17.abrupt("break", 19);

              case 17:
                // publish message
                _this18.$eventBus.$emit("deleteProviderDocument", _this18.deleteId);
                return _context17.abrupt("break", 19);

              case 19:
                _this18.deleteId = null;
                _this18.deleteOption = null;
                $("#deletemodal").modal("hide");
                _context17.next = 27;
                break;

              case 24:
                _context17.prev = 24;
                _context17.t2 = _context17["catch"](0);

                if (_context17.t2.errors) {
                  for (_index = 0; _index < _context17.t2.errors.length; _index++) {
                    _this18.$notification.error(_context17.t2.errors[_index], { title: "Error" });
                  }
                }

              case 27:
                _context17.prev = 27;

                _this18.isLoading = false;
                return _context17.finish(27);

              case 30:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, _this18, [[0, 24, 27, 30], [5, 13]]);
      }))();
    },
    viewDocument: function viewDocument(item) {
      // publish message
      this.$eventBus.$emit("initializeProviderDocument", item);
    },
    addContactPerson: function addContactPerson() {
      this.model.contactPeople.push({
        title: "Mr",
        otherTitle: null,
        fullName: null,
        email: null,
        phoneCode: null,
        phoneNumber: null
      });
    },
    removeContactPerson: function removeContactPerson(index) {
      this.model.contactPeople.splice(index, 1);
    },
    printPhone: function printPhone(item) {
      return item.phoneCode && item.phoneNumber && item.phoneCode.length > 0 && item.phoneNumber.length > 0 ? "(+" + item.phoneCode + ") " + item.phoneNumber : "";
    },
    momentDate: function momentDate(time) {
      return __WEBPACK_IMPORTED_MODULE_7_moment___default()(time).parseZone().format("D MMMM YYYY hh:mm:ss");
    }
  }
});

/***/ }),

/***/ 739:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_master_provider_providerDocumentService_js__ = __webpack_require__(922);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    isAllowToRead: function isAllowToRead() {
      return this.allPermissions.includes("Read");
    },
    isAllowToCreate: function isAllowToCreate() {
      return this.allPermissions.includes("Create");
    },
    isAllowToUpdate: function isAllowToUpdate() {
      return this.allPermissions.includes("Update");
    },
    isAllowToDelete: function isAllowToDelete() {
      return this.allPermissions.includes("Delete");
    }
  },
  data: function data() {
    return {
      isSubmitted: false,
      allPermissions: [],
      isViewOnly: false,
      selectedProvider: null,
      document: null,
      items: [],
      model: {},
      isUpdate: false,
      isLoading: false,
      msg: "Please wait"
    };
  },
  validations: function validations() {
    return {
      model: {
        name: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"], maxLength: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["maxLength"])(100) }
      }
    };
  },
  created: function created() {
    // subscribe message
    this.$eventBus.$on("initializeProviderDocument", this.initialize);
    this.$eventBus.$on("deleteProviderDocument", this.deleteItem);
    this.$eventBus.$on("openModalProviderDocument", this.openModal);
  },
  beforeDestroy: function beforeDestroy() {
    this.$eventBus.$off("initializeProviderDocument");
    this.$eventBus.$off("deleteProviderDocument");
    this.$eventBus.$off("openModalProviderDocument");
    this.closeModal();
  },

  methods: {
    openModal: function openModal() {
      $(this.$refs.providerdocumentmodal).modal({ backdrop: "static", keyboard: false });
      $(this.$refs.providerdocumentmodal).css("overflow-y", "auto");
    },
    closeModal: function closeModal() {
      $(this.$refs.providerdocumentmodal).modal("hide");
    },
    initialize: function initialize(provider) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var profile, permissions, uploader;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                _this.isLoading = true;
                _this.isViewOnly = !provider.isOwnInventory;
                _this.reset();
                _this.selectedProvider = provider;

                _context.next = 7;
                return _this.$store.dispatch("user/getProfile");

              case 7:
                profile = _context.sent;
                permissions = profile.services["ProviderDocument"];

                if (permissions) {
                  _this.allPermissions = permissions;
                }

                if (!_this.isAllowToRead) {
                  _context.next = 13;
                  break;
                }

                _context.next = 13;
                return _this.getAll();

              case 13:
                _this.openModal();
                uploader = document.getElementById("provider-document-uploader");

                if (uploader) {
                  uploader.value = "";
                }

              case 16:
                _context.prev = 16;

                _this.isLoading = false;
                return _context.finish(16);

              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[0,, 16, 19]]);
      }))();
    },
    bindModel: function bindModel(object) {
      var uploader = document.getElementById("provider-document-uploader");
      if (uploader) {
        uploader.value = "";
      }
      this.isUpdate = true;
      this.document = null;
      this.resetValidations();
      this.model = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, object);
    },
    reset: function reset() {
      var uploader = document.getElementById("provider-document-uploader");
      if (uploader) {
        uploader.value = "";
      }
      this.isUpdate = false;
      this.document = null;
      this.resetValidations();
      this.model = {};
    },
    resetValidations: function resetValidations() {
      this.isSubmitted = false;
      this.$v.model.$reset();
    },
    getAll: function getAll() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __WEBPACK_IMPORTED_MODULE_4__services_master_provider_providerDocumentService_js__["a" /* default */].getAll(_this2.selectedProvider.id);

              case 2:
                _this2.items = _context2.sent;

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    onChangeDocument: function onChangeDocument(files) {
      var maxSize = 4 * 1024 * 1024;
      if (files[0].size > maxSize) {
        this.document = null;
        document.getElementById("provider-document-uploader").value = "";
        alert("File is too big, max-size is  " + parseInt(maxSize / 1000000) + "MB.");
        return;
      }
      var fileExt = files[0].name.substring(files[0].name.lastIndexOf(".") + 1).toLowerCase();
      if (!["jpeg", "jpg", "png", "pdf", "xls", "xlsx", "doc", "docx"].includes(fileExt)) {
        this.document = null;
        document.getElementById("provider-document-uploader").value = "";
        alert("Invalid file type.");
        return;
      }
      this.document = files[0];
    },
    submit: function submit() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var formData, key, index;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.isSubmitted = true;
                _this3.$v.model.$touch();

                if (!_this3.$v.model.$error) {
                  _context3.next = 4;
                  break;
                }

                return _context3.abrupt("return");

              case 4:
                _context3.prev = 4;

                _this3.isLoading = true;
                _this3.model.providerId = _this3.selectedProvider.id;

                if (_this3.isUpdate) {
                  _context3.next = 16;
                  break;
                }

                formData = new FormData();

                for (key in _this3.model) {
                  if (_this3.model.hasOwnProperty(key)) {
                    formData.append(key, _this3.model[key]);
                  }
                }
                formData.append(_this3.document.name, _this3.document);
                _context3.next = 13;
                return __WEBPACK_IMPORTED_MODULE_4__services_master_provider_providerDocumentService_js__["a" /* default */].create(formData);

              case 13:
                _this3.$notification.success("Successfully added.", { title: "Success" });
                _context3.next = 19;
                break;

              case 16:
                _context3.next = 18;
                return __WEBPACK_IMPORTED_MODULE_4__services_master_provider_providerDocumentService_js__["a" /* default */].update(_this3.model);

              case 18:
                _this3.$notification.success("Successfully updated.", { title: "Success" });

              case 19:
                _this3.reset();
                _context3.next = 22;
                return _this3.getAll();

              case 22:
                _context3.next = 27;
                break;

              case 24:
                _context3.prev = 24;
                _context3.t0 = _context3["catch"](4);

                if (_context3.t0.errors) {
                  for (index = 0; index < _context3.t0.errors.length; index++) {
                    _this3.$notification.error(_context3.t0.errors[index], { title: "Error" });
                  }
                }

              case 27:
                _context3.prev = 27;

                _this3.isLoading = false;
                return _context3.finish(27);

              case 30:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[4, 24, 27, 30]]);
      }))();
    },
    changeStatus: function changeStatus(item) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var index;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;

                _this4.isLoading = true;
                item.providerId = _this4.selectedProvider.id;
                _context4.next = 5;
                return __WEBPACK_IMPORTED_MODULE_4__services_master_provider_providerDocumentService_js__["a" /* default */].update(item);

              case 5:
                _this4.$notification.success("Successfully updated.", { title: "Success" });
                _this4.reset();
                _context4.next = 9;
                return _this4.getAll();

              case 9:
                _context4.next = 14;
                break;

              case 11:
                _context4.prev = 11;
                _context4.t0 = _context4["catch"](0);

                if (_context4.t0.errors) {
                  for (index = 0; index < _context4.t0.errors.length; index++) {
                    _this4.$notification.error(_context4.t0.errors[index], { title: "Error" });
                  }
                }

              case 14:
                _context4.prev = 14;

                _this4.isLoading = false;
                return _context4.finish(14);

              case 17:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[0, 11, 14, 17]]);
      }))();
    },
    confirmDelete: function confirmDelete(item) {
      this.closeModal();
      // publish message
      this.$eventBus.$emit("openProviderDeleteModal", "providerDocument", item.id);
    },
    deleteItem: function deleteItem(id) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var index;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;

                _this5.isLoading = true;
                _context5.next = 4;
                return __WEBPACK_IMPORTED_MODULE_4__services_master_provider_providerDocumentService_js__["a" /* default */].delete(id);

              case 4:
                _this5.$notification.success("Successfully deleted.", { title: "Success" });
                _this5.reset();
                _context5.next = 8;
                return _this5.getAll();

              case 8:
                _this5.openModal();
                _context5.next = 14;
                break;

              case 11:
                _context5.prev = 11;
                _context5.t0 = _context5["catch"](0);

                if (_context5.t0.errors) {
                  for (index = 0; index < _context5.t0.errors.length; index++) {
                    _this5.$notification.error(_context5.t0.errors[index], { title: "Error" });
                  }
                }

              case 14:
                _context5.prev = 14;

                _this5.isLoading = false;
                return _context5.finish(14);

              case 17:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this5, [[0, 11, 14, 17]]);
      }))();
    },
    viewDocument: function viewDocument(id) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var response, index;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;

                _this6.isLoading = true;
                _context6.next = 4;
                return __WEBPACK_IMPORTED_MODULE_4__services_master_provider_providerDocumentService_js__["a" /* default */].view(id);

              case 4:
                response = _context6.sent;

                window.open(response.data, "_blank");
                _context6.next = 11;
                break;

              case 8:
                _context6.prev = 8;
                _context6.t0 = _context6["catch"](0);

                if (_context6.t0.errors) {
                  for (index = 0; index < _context6.t0.errors.length; index++) {
                    _this6.$notification.error(_context6.t0.errors[index], { title: "Error" });
                  }
                }

              case 11:
                _context6.prev = 11;

                _this6.isLoading = false;
                return _context6.finish(11);

              case 14:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this6, [[0, 8, 11, 14]]);
      }))();
    },
    printFileSize: function printFileSize(size) {
      return this.$helper.printFileSize(size);
    }
  }
});

/***/ }),

/***/ 919:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(920);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(384)("761758e5", content, true, {});

/***/ }),

/***/ 920:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(383)(true);
// imports


// module
exports.push([module.i, "ul li .action-draft-history[data-v-9d98522c]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;gap:4px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}ul.aggreement-wrapper li span[data-v-9d98522c]{color:gray;font-size:13px;font-weight:400}ul li .action-draft-history button[data-v-9d98522c]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:transparent;padding:3px;border:none;border-radius:3px;width:30px}ul li .action-draft-history button[data-v-9d98522c]:hover{background:#edf6ec}ul li .action-draft-history button svg[data-v-9d98522c]{color:#363636;width:17px}.list-terms-conditions[data-v-9d98522c]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;gap:8px;padding:10px 5px;overflow:hidden;border:.5px dotted #4fb848;border-radius:5px}ul li.list-terms-conditions[data-v-9d98522c]:not(:first-child){margin-top:15px}ul li.list-terms-conditions.active-list-item[data-v-9d98522c]{border-bottom:none;border-radius:5px;border:1px dotted #4fb848;background:#4fb848}ul li.list-terms-conditions.active-list-item .author-tnc[data-v-9d98522c],ul li.list-terms-conditions.active-list-item .date-time-tnc[data-v-9d98522c]{color:#edf6ec}ul li.list-terms-conditions.active-list-item button[data-v-9d98522c]{border:1px dotted #edf6ec}ul li.list-terms-conditions.active-list-item button svg[data-v-9d98522c]{color:#edf6ec}ul li.list-terms-conditions.active-list-item button:hover svg[data-v-9d98522c]{color:#4fb848}.list-terms-conditions .version-badge[data-v-9d98522c]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;width:60px;height:45px;border-radius:5px;background:#edf6ec;color:#4fb848;font-weight:800;font-size:20px}.description-list-tnc-wrapper[data-v-9d98522c]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;min-width:85%}.description-list-tnc-wrapper .author-tnc[data-v-9d98522c]{font-size:12px;font-weight:600}.description-list-tnc-wrapper .date-time-tnc[data-v-9d98522c]{font-size:11px;color:gray;font-weight:400}", "", {"version":3,"sources":["/app/src/components/master/provider/Provider.vue"],"names":[],"mappings":"AACA,6CACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,sBAAuB,AAC/B,QAAS,AACT,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,kBAAoB,CAC7B,AACD,+CACE,WAAe,AACf,eAAgB,AAChB,eAAiB,CAClB,AACD,oDACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,uBAAwB,AACxB,YAAa,AACb,YAAa,AACb,kBAAmB,AACnB,UAAY,CACb,AACD,0DACE,kBAAoB,CACrB,AACD,wDACE,cAAe,AACf,UAAY,CACb,AACD,wCACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,QAAS,AACT,iBAAkB,AAClB,gBAAiB,AACjB,2BAA6B,AAC7B,iBAAmB,CACpB,AACD,+DACE,eAAiB,CAClB,AACD,8DACE,mBAAoB,AACpB,kBAAmB,AACnB,0BAA2B,AAC3B,kBAAoB,CACrB,AACD,uJAEE,aAAe,CAChB,AACD,qEACE,yBAA2B,CAC5B,AACD,yEACE,aAAe,CAChB,AACD,+EACE,aAAe,CAChB,AACD,uDACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,WAAY,AACZ,YAAa,AACb,kBAAmB,AACnB,mBAAoB,AACpB,cAAe,AACf,gBAAiB,AACjB,cAAgB,CACjB,AACD,+CACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,sBAAuB,AAC/B,uBAAwB,AACpB,oBAAqB,AACjB,2BAA4B,AACpC,aAAe,CAChB,AACD,2DACE,eAAgB,AAChB,eAAiB,CAClB,AACD,8DACE,eAAgB,AAChB,WAAe,AACf,eAAiB,CAClB","file":"Provider.vue","sourcesContent":["\nul li .action-draft-history[data-v-9d98522c] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  gap: 4px;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\nul.aggreement-wrapper li span[data-v-9d98522c] {\n  color: #808080;\n  font-size: 13px;\n  font-weight: 400;\n}\nul li .action-draft-history button[data-v-9d98522c] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  background: transparent;\n  padding: 3px;\n  border: none;\n  border-radius: 3px;\n  width: 30px;\n}\nul li .action-draft-history button[data-v-9d98522c]:hover {\n  background: #edf6ec;\n}\nul li .action-draft-history button svg[data-v-9d98522c] {\n  color: #363636;\n  width: 17px;\n}\n.list-terms-conditions[data-v-9d98522c] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: start;\n      -ms-flex-align: start;\n          align-items: flex-start;\n  gap: 8px;\n  padding: 10px 5px;\n  overflow: hidden;\n  border: 0.5px dotted #4fb848;\n  border-radius: 5px;\n}\nul li.list-terms-conditions[data-v-9d98522c]:not(:first-child) {\n  margin-top: 15px;\n}\nul li.list-terms-conditions.active-list-item[data-v-9d98522c] {\n  border-bottom: none;\n  border-radius: 5px;\n  border: 1px dotted #4fb848;\n  background: #4fb848;\n}\nul li.list-terms-conditions.active-list-item .author-tnc[data-v-9d98522c],\nul li.list-terms-conditions.active-list-item .date-time-tnc[data-v-9d98522c] {\n  color: #edf6ec;\n}\nul li.list-terms-conditions.active-list-item button[data-v-9d98522c] {\n  border: 1px dotted #edf6ec;\n}\nul li.list-terms-conditions.active-list-item button svg[data-v-9d98522c] {\n  color: #edf6ec;\n}\nul li.list-terms-conditions.active-list-item button:hover svg[data-v-9d98522c] {\n  color: #4fb848;\n}\n.list-terms-conditions .version-badge[data-v-9d98522c] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  width: 60px;\n  height: 45px;\n  border-radius: 5px;\n  background: #edf6ec;\n  color: #4fb848;\n  font-weight: 800;\n  font-size: 20px;\n}\n.description-list-tnc-wrapper[data-v-9d98522c] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: start;\n      -ms-flex-pack: start;\n          justify-content: flex-start;\n  min-width: 85%;\n}\n.description-list-tnc-wrapper .author-tnc[data-v-9d98522c] {\n  font-size: 12px;\n  font-weight: 600;\n}\n.description-list-tnc-wrapper .date-time-tnc[data-v-9d98522c] {\n  font-size: 11px;\n  color: #808080;\n  font-weight: 400;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 921:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProviderDocument_vue__ = __webpack_require__(739);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ed765cb6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProviderDocument_vue__ = __webpack_require__(923);
var normalizeComponent = __webpack_require__(56)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProviderDocument_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ed765cb6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProviderDocument_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 922:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);



var endpoint = "https://prod-gateway-opsicar.idteknologia.net" + '/api/master/providerDocuments';

/* harmony default export */ __webpack_exports__["a"] = ({
  getAll: function getAll(providerId) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + ('/list/' + providerId)).then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context.abrupt('return', _context.sent);

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  view: function view(id) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + ('/item/' + id)).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context2.abrupt('return', _context2.sent);

            case 3:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  create: function create(request) {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint, request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context3.abrupt('return', _context3.sent);

            case 3:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  update: function update(request) {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(endpoint, request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context4.abrupt('return', _context4.sent);

            case 3:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  delete: function _delete(id) {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.delete(endpoint + ('/' + id)).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context5.abrupt('return', _context5.sent);

            case 3:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  }
});

/***/ }),

/***/ 923:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.selectedProvider)?_c('div',[_c('div',{ref:"providerdocumentmodal",staticClass:"modal fade",attrs:{"role":"dialog"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header modal-new",class:{ update: _vm.isUpdate }},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-10"},[_c('h4',[_vm._v("Provider Document ("+_vm._s(_vm.selectedProvider.name)+")")]),_vm._v(" "),(_vm.model.modifiedDate)?_c('h6',[_vm._v("\n                Last Updated: "+_vm._s(_vm.model.modifiedDate.stringFullDate)+"\n              ")]):_vm._e()]),_vm._v(" "),_vm._m(0)])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"modal-wrapper modal-detail"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"modal-content-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-3 divider-right pr-25"},[(_vm.$v.model.$error)?_c('div',{staticClass:"summary-error"},[_vm._v("\n                          This form has errors\n                        ")]):_vm._e(),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}}},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.name),expression:"model.name"}],staticClass:"form-control",class:{
                                'field-error': _vm.isSubmitted && _vm.$v.model.name.$error,
                              },attrs:{"type":"text","autocomplete":"off","disabled":_vm.isViewOnly},domProps:{"value":(_vm.model.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "name", $event.target.value)}}}),_vm._v(" "),(_vm.isSubmitted && _vm.$v.model.name.$error)?_c('div',[(!_vm.$v.model.name.required)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Name is required")]):_vm._e(),_vm._v(" "),(!_vm.$v.model.name.maxLength)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Name must be less than\n                                "+_vm._s(_vm.$v.model.name.$params.maxLength.max)+"\n                                characters")]):_vm._e()]):_vm._e()]),_vm._v(" "),(
                              !_vm.isUpdate &&
                              !_vm.isViewOnly &&
                              (_vm.isAllowToCreate || _vm.isAllowToUpdate)
                            )?_c('div',{staticClass:"mb-15"},[_c('input',{staticClass:"custom-file-input input-uploader",attrs:{"id":"provider-document-uploader","type":"file","accept":"image/jpeg,image/png,application/pdf,application/vnd.ms-excel","name":"document","required":""},on:{"change":function($event){return _vm.onChangeDocument($event.target.files)}}})]):_vm._e(),_vm._v(" "),(!_vm.isViewOnly && (_vm.isAllowToCreate || _vm.isAllowToUpdate))?_c('div',{staticClass:"modal-footer"},[(_vm.isAllowToCreate || _vm.isAllowToUpdate)?_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.reset()}}},[_vm._v("\n                              Reset\n                            ")]):_vm._e(),_vm._v(" "),(!_vm.isUpdate && _vm.isAllowToCreate)?_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("\n                              Create\n                            ")]):_vm._e(),_vm._v(" "),(_vm.isUpdate && _vm.isAllowToUpdate)?_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("\n                              Update\n                            ")]):_vm._e()]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-sm-9 divider-left pl-20"},[_c('div',{staticClass:"table-modal-detail"},[_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-hover table-fix mtz"},[_c('thead',[_c('tr',[_c('th',{staticClass:"number"},[_vm._v("No")]),_vm._v(" "),_c('th',[_vm._v("Name")]),_vm._v(" "),_c('th',[_vm._v("Size")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Status")]),_vm._v(" "),(!_vm.isViewOnly)?_c('th',{staticClass:"text-center"},[_vm._v("Action")]):_vm._e()])]),_vm._v(" "),_c('tbody',_vm._l((_vm.items),function(item,index){return _c('tr',{key:item.id},[_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(index + 1))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.printFileSize(item.size)))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('label',{staticClass:"cursor-pointer"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.isActive),expression:"item.isActive"}],staticClass:"control-checkbox",attrs:{"type":"checkbox","disabled":_vm.isViewOnly || !_vm.isAllowToUpdate},domProps:{"checked":Array.isArray(item.isActive)?_vm._i(item.isActive,null)>-1:(item.isActive)},on:{"change":[function($event){var $$a=item.isActive,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(item, "isActive", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(item, "isActive", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(item, "isActive", $$c)}},function($event){return _vm.changeStatus(item)}]}}),_vm._v(" "),_c('span',{staticClass:"pl-5 font-weight-normal v-align-middle"},[_vm._v("\n                                        "+_vm._s(item.isActive ? "Active" : "Inactive")+"\n                                      ")])])]),_vm._v(" "),(!_vm.isViewOnly)?_c('td',{staticClass:"text-center"},[_c('div',{staticClass:"button-action-wrapper"},[(_vm.isAllowToUpdate)?_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){return _vm.bindModel(item)}}},[_c('span',[_vm._v("Edit")])]):_vm._e(),_vm._v(" "),(_vm.isAllowToDelete)?_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){return _vm.confirmDelete(item)}}},[_c('i',{staticClass:"ic-close"})]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-default --green35",attrs:{"type":"button"},on:{"click":function($event){return _vm.viewDocument(item.id)}}},[_c('span',[_vm._v("View")])])])]):_vm._e()])}),0)])])])])])])])])])])])])])]),_vm._v(" "),_c('loader',{attrs:{"content":_vm.msg,"visible":_vm.isLoading}})],1):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-2"},[_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('i',{staticClass:"ic-close"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 924:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);



var endpoint = "https://prod-gateway-opsicar.idteknologia.net" + '/api/master/regionformats';

/* harmony default export */ __webpack_exports__["a"] = ({
  getAll: function getAll() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + '/list').then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context.abrupt('return', _context.sent);

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),

/***/ 925:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return operatingCityService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_apiService__ = __webpack_require__(500);



var _this = this;



var _baseEndpoint = "https://prod-gateway-opsicar.idteknologia.net" + '/api/master/operatingCities';

var operatingCityService = {
  getAllAsync: function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(country, isActive, onBeginCallback, onFinallyCallback) {
      var query;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(country || isActive === true || isActive === false)) {
                _context.next = 5;
                break;
              }

              query = [];


              if (country) {
                if (Array.isArray(country)) {
                  country.forEach(function (item) {
                    query.push('country=' + item);
                  });
                }
                if (typeof country === "string" || country instanceof String) {
                  query.push('country=' + country);
                }
              }

              if (isActive === true || isActive === false) {
                query.push('active=' + isActive);
              }

              return _context.abrupt('return', __WEBPACK_IMPORTED_MODULE_2__services_apiService__["a" /* asyncApi */].get(_baseEndpoint + '?' + query.join('&'), onBeginCallback, onFinallyCallback));

            case 5:
              return _context.abrupt('return', __WEBPACK_IMPORTED_MODULE_2__services_apiService__["a" /* asyncApi */].get('' + _baseEndpoint, onBeginCallback, onFinallyCallback));

            case 6:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function getAllAsync(_x, _x2, _x3, _x4) {
      return _ref.apply(this, arguments);
    };
  }()
};



/***/ }),

/***/ 926:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"section-header-info"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"content-header-info"},[_c('div',{staticClass:"col-sm-12"},[(_vm.isAllowToCreate)?_c('button',{staticClass:"btn btn-primary pull-left",on:{"click":function($event){return _vm.createItem()}}},[_c('span',[_vm._v("+")]),_vm._v(" Create New\n              ")]):_vm._e(),_vm._v(" "),_vm._m(1)])])])])])]),_vm._v(" "),_c('section',{staticClass:"middle-content"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"dataTables_filter"},[_c('i',{staticClass:"ic-search"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.table.keyword),expression:"table.keyword"}],staticClass:"form-control",attrs:{"type":"search","placeholder":"Search Provider or Representative Name"},domProps:{"value":(_vm.table.keyword)},on:{"keyup":function($event){return _vm.onKeyupKeyword()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.table, "keyword", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"dataTables_length pull-right"},[_c('label',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.table.pageSize),expression:"table.pageSize"}],staticClass:"form-control v-select",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.table, "pageSize", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.onChangePageSize()}]}},_vm._l((_vm.table.pageSizes),function(item){return _c('option',{key:item,domProps:{"value":item}},[_vm._v("\n                  "+_vm._s(item)+"\n                ")])}),0),_vm._v("\n              Entries")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"table-accordion table-p15"},[_c('table',{staticClass:"table table-hover table-striped table-sticky"},[_c('thead',[_c('tr',[_c('th',[_vm._v("\n                  Name\n                  "),_c('span',{staticClass:"button-sort",on:{"click":function($event){return _vm.onClickSort('name')}}},[_c('i',{staticClass:"ic-Switch-Vertical"})])]),_vm._v(" "),_c('th',[_vm._v("\n                  Phone\n                  "),_c('span',{staticClass:"button-sort",on:{"click":function($event){return _vm.onClickSort('phone')}}},[_c('i',{staticClass:"ic-Switch-Vertical"})])]),_vm._v(" "),_c('th',[_vm._v("\n                  City\n                  "),_c('span',{staticClass:"button-sort",on:{"click":function($event){return _vm.onClickSort('city')}}},[_c('i',{staticClass:"ic-Switch-Vertical"})])]),_vm._v(" "),_c('th',[_vm._v("Region Format")]),_vm._v(" "),_c('th',{staticClass:"text-left"},[_vm._v("Source")]),_vm._v(" "),_c('th',{staticClass:"text-left"},[_vm._v("Status")])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.items),function(item){return _c('tr',{key:item.id,staticClass:"detail-row"},[_c('td',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('td',{staticClass:"pos-rel"},[_vm._v("\n                  "+_vm._s(_vm.printPhone(item))+"\n                  "),_c('div',{staticClass:"row-big-menu"},[_c('ul',[(!item.isOwnInventory)?_c('li',[_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){return _vm.viewItem(item)}}},[_c('span',[_vm._v("View")])])]):_vm._e(),_vm._v(" "),(item.isOwnInventory && _vm.isAllowToUpdate)?_c('li',[_c('button',{staticClass:"btn btn-default --blue",attrs:{"type":"button"},on:{"click":function($event){return _vm.updateItem(item)}}},[_c('span',[_vm._v("Edit")])])]):_vm._e(),_vm._v(" "),(item.isOwnInventory && _vm.isAllowToDelete)?_c('li',[_c('button',{staticClass:"btn btn-default sts-danger",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.openDeleteModal('provider', item.id)}}},[_c('span',[_vm._v("Delete")])])]):_vm._e(),_vm._v(" "),(item.isOwnInventory && _vm.isAllowToUpdate)?_c('li',[_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){return _vm.viewDocument(item)}}},[_c('span',[_vm._v("Document")])])]):_vm._e()])])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.city))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.regionFormat.title))]),_vm._v(" "),_c('td',{staticClass:"text-left"},[_vm._v(_vm._s(item.source))]),_vm._v(" "),_c('td',{staticClass:"text-left"},[_c('label',{staticClass:"cursor-pointer"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.isActive),expression:"item.isActive"}],staticClass:"control-checkbox",attrs:{"type":"checkbox","disabled":!item.isOwnInventory || !_vm.isAllowToUpdate},domProps:{"checked":Array.isArray(item.isActive)?_vm._i(item.isActive,null)>-1:(item.isActive)},on:{"change":[function($event){var $$a=item.isActive,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(item, "isActive", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(item, "isActive", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(item, "isActive", $$c)}},function($event){return _vm.changeStatus(item)}]}}),_vm._v(" "),_c('span',{staticClass:"pl-5 font-weight-normal v-align-middle"},[_vm._v("\n                      "+_vm._s(item.isActive ? "Active" : "Inactive")+"\n                    ")])])])])}),0)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-5"},[_c('div',{staticClass:"dataTables_info --blue25"},[_c('strong',[_vm._v(_vm._s(_vm.recordInfo))])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-7"},[_c('nav',{attrs:{"aria-label":"..."}},[_c('paginate',{attrs:{"page-count":_vm.table.totalPages,"click-handler":_vm.onNavigateCallback,"prev-text":'Previous',"next-text":'Next',"container-class":'pagination pull-right'},model:{value:(_vm.table.pageNumber),callback:function ($$v) {_vm.$set(_vm.table, "pageNumber", $$v)},expression:"table.pageNumber"}})],1)])])])]),_vm._v(" "),_c('div',{ref:"providermodal",staticClass:"modal fade",attrs:{"role":"dialog"}},[_c('div',{staticClass:"modal-dialog modal-md"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header modal-new",class:{ update: _vm.isUpdate }},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-10"},[_c('h4',[_vm._v("Provider")]),_vm._v(" "),(_vm.model.modifiedDate)?_c('h6',[_vm._v("\n                Last Updated: "+_vm._s(_vm.model.modifiedDate.stringFullDate)+"\n              ")]):_vm._e()]),_vm._v(" "),_vm._m(2)])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"modal-wrapper"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"modal-content-body mt-5"},[_c('ul',{staticClass:"nav nav-tabs nav-justified nav-tab-modal tabs-mini-form"},[_c('li',{class:[_vm.activeTab === 'general' ? 'active' : '']},[_c('a',{attrs:{"href":"#provider-company","data-toggle":"tab"},on:{"click":function($event){_vm.activeTab = 'general'}}},[_c('span',{staticClass:"required"},[_vm._v("Company")])])]),_vm._v(" "),_c('li',{class:[_vm.activeTab === 'contact' ? 'active' : '']},[_c('a',{attrs:{"href":"#provider-contact-person","data-toggle":"tab"},on:{"click":function($event){_vm.activeTab = 'contact'}}},[_c('span',[_vm._v("Contact Person")])])]),_vm._v(" "),_c('li',{class:[_vm.activeTab === 'payment' ? 'active' : '']},[_c('a',{attrs:{"href":"#provider-payment","data-toggle":"tab"},on:{"click":function($event){_vm.activeTab = 'payment'}}},[_c('span',[_vm._v("Payment")])])])]),_vm._v(" "),(_vm.$v.model.$error || _vm.$v.location.$error)?_c('div',{staticClass:"summary-error"},[_vm._v("\n                  This form has errors\n                ")]):_vm._e(),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}}},[_c('div',{staticClass:"tab-content"},[_c('div',{staticClass:"tab-pane fade",class:[_vm.activeTab === 'general' ? 'in active' : ''],attrs:{"id":"provider-company"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[(_vm.imageData && !_vm.isViewOnly)?_c('div',[_c('cropper',{ref:"cropper",staticClass:"cropper-box",attrs:{"src":_vm.imagePreview}})],1):_vm._e(),_vm._v(" "),(!_vm.imageData && _vm.imagePreview)?_c('div',{staticClass:"logo-provider"},[_c('img',{staticStyle:{"height":"225px"},attrs:{"src":_vm.imagePreview,"alt":""}})]):_vm._e(),_vm._v(" "),(!_vm.isViewOnly)?_c('div',{staticClass:"btn-upload-wrapper"},[_c('button',{staticClass:"btn btn-upload"},[_c('i',{staticClass:"ic-up"}),_vm._v("\n                              "+_vm._s(_vm.model.imageUri
                                  ? "Change picture"
                                  : "Upload picture")+"\n                            ")]),_vm._v(" "),_c('input',{attrs:{"id":"image-uploader","type":"file","name":"image","accept":"image/jpeg,image/png"},on:{"change":function($event){return _vm.onChangeImage($event.target.files)}}}),_vm._v(" "),(_vm.imageData)?_c('button',{staticClass:"btn btn-default btn-block text-center",on:{"click":function($event){return _vm.resetImage()}}},[_vm._v("\n                              Clear\n                            ")]):_vm._e()]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("Company Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.name),expression:"model.name"}],staticClass:"form-control",class:{
                                'field-error':
                                  _vm.isSubmitted && _vm.$v.model.name.$error,
                              },attrs:{"type":"text","autocomplete":"off","disabled":_vm.isViewOnly},domProps:{"value":(_vm.model.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "name", $event.target.value)}}}),_vm._v(" "),(_vm.isSubmitted && _vm.$v.model.name.$error)?_c('div',[(!_vm.$v.model.name.required)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Name is required")]):_vm._e(),_vm._v(" "),(!_vm.$v.model.name.maxLength)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Name must be less than\n                                "+_vm._s(_vm.$v.model.name.$params.maxLength.max)+"\n                                characters")]):_vm._e()]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("Company Email")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.email),expression:"model.email"}],staticClass:"form-control",class:{
                                'field-error':
                                  _vm.isSubmitted && _vm.$v.model.email.$error,
                              },attrs:{"type":"text","autocomplete":"off","disabled":_vm.isViewOnly},domProps:{"value":(_vm.model.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "email", $event.target.value)}}}),_vm._v(" "),(_vm.isSubmitted && _vm.$v.model.email.$error)?_c('div',[(!_vm.$v.model.email.required)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Email is required")]):_vm._e(),_vm._v(" "),(!_vm.$v.model.email.email)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Email is invalid")]):_vm._e(),_vm._v(" "),(!_vm.$v.model.email.maxLength)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Email must be less than\n                                "+_vm._s(_vm.$v.model.email.$params.maxLength.max)+"\n                                characters")]):_vm._e()]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Alternate Company Email")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.alternateEmail),expression:"model.alternateEmail"}],staticClass:"form-control",class:{
                                'field-error':
                                  _vm.isSubmitted &&
                                  _vm.$v.model.alternateEmail.$error,
                              },attrs:{"type":"text","autocomplete":"off","disabled":_vm.isViewOnly},domProps:{"value":(_vm.model.alternateEmail)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "alternateEmail", $event.target.value)}}}),_vm._v(" "),(
                                _vm.isSubmitted && _vm.$v.model.alternateEmail.$error
                              )?_c('div',[(!_vm.$v.model.alternateEmail.email)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Alternate Email is invalid")]):_vm._e(),_vm._v(" "),(!_vm.$v.model.alternateEmail.maxLength)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Alternate Email must be less than\n                                "+_vm._s(_vm.$v.model.alternateEmail.$params.maxLength
                                    .max)+"\n                                characters")]):_vm._e()]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('label',{staticClass:"required"},[_vm._v("Company Phone")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-5"},[_c('div',{staticClass:"form-group"},[_c('v-select',{staticClass:"v-search-select",class:{
                                    'field-error':
                                      _vm.isSubmitted &&
                                      _vm.$v.model.phoneCode.$error,
                                  },attrs:{"placeholder":"","label":"label","options":_vm.phoneCodes,"filter":_vm.searchPhoneCode,"clearable":true,"searchable":true,"filterable":true,"reduce":function (option) { return option.dial; },"disabled":_vm.isViewOnly},scopedSlots:_vm._u([{key:"option",fn:function(option){return [_c('div',{staticClass:"phone-wrapper"},[_c('div',{staticClass:"phone-icon",class:option.icon}),_vm._v(" "),_c('div',{staticClass:"phone-text"},[_vm._v("\n                                        "+_vm._s(option.country)+"\n                                      ")])])]}}]),model:{value:(_vm.model.phoneCode),callback:function ($$v) {_vm.$set(_vm.model, "phoneCode", $$v)},expression:"model.phoneCode"}}),_vm._v(" "),(
                                    _vm.isSubmitted &&
                                    !_vm.$v.model.phoneCode.required
                                  )?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Phone Code is required")]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"col-sm-7"},[_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sanitizePhoneNumber),expression:"sanitizePhoneNumber"}],staticClass:"form-control numbers-only",class:{
                                    'field-error':
                                      _vm.isSubmitted &&
                                      _vm.$v.model.phoneNumber.$error,
                                  },attrs:{"type":"text","autocomplete":"off","disabled":_vm.isViewOnly},domProps:{"value":(_vm.sanitizePhoneNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.sanitizePhoneNumber=$event.target.value}}}),_vm._v(" "),(
                                    _vm.isSubmitted && _vm.$v.model.phoneNumber.$error
                                  )?_c('div',[(!_vm.$v.model.phoneNumber.required)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Phone Number is required")]):_vm._e(),_vm._v(" "),(!_vm.$v.model.phoneNumber.maxLength)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Phone Number must be less than\n                                    "+_vm._s(_vm.$v.model.phoneNumber.$params.maxLength
                                        .max)+"\n                                    characters")]):_vm._e()]):_vm._e()])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('label',[_vm._v("Alternate Company Phone")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-5"},[_c('div',{staticClass:"form-group"},[_c('v-select',{staticClass:"v-search-select",attrs:{"placeholder":"","label":"label","options":_vm.phoneCodes,"filter":_vm.searchPhoneCode,"clearable":true,"searchable":true,"filterable":true,"reduce":function (option) { return option.dial; },"disabled":_vm.isViewOnly},scopedSlots:_vm._u([{key:"option",fn:function(option){return [_c('div',{staticClass:"phone-wrapper"},[_c('div',{staticClass:"phone-icon",class:option.icon}),_vm._v(" "),_c('div',{staticClass:"phone-text"},[_vm._v("\n                                        "+_vm._s(option.country)+"\n                                      ")])])]}}]),model:{value:(_vm.model.alternatePhoneCode),callback:function ($$v) {_vm.$set(_vm.model, "alternatePhoneCode", $$v)},expression:"model.alternatePhoneCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-sm-7"},[_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sanitizeAltPhoneNumber),expression:"sanitizeAltPhoneNumber"}],staticClass:"form-control numbers-only",class:{
                                    'field-error':
                                      _vm.isSubmitted &&
                                      _vm.$v.model.alternatePhoneNumber.$error,
                                  },attrs:{"type":"text","autocomplete":"off","disabled":_vm.isViewOnly},domProps:{"value":(_vm.sanitizeAltPhoneNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.sanitizeAltPhoneNumber=$event.target.value}}}),_vm._v(" "),(
                                    _vm.isSubmitted &&
                                    !_vm.$v.model.alternatePhoneNumber.maxLength
                                  )?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Alt. Phone Number must be less than\n                                  "+_vm._s(_vm.$v.model.alternatePhoneNumber.$params
                                      .maxLength.max)+"\n                                  characters")]):_vm._e()])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v(" Operating Cities ")]),_vm._v(" "),_c('multiselect',{class:{
                                'field-error':
                                  _vm.isSubmitted &&
                                  _vm.$v.model.operatingCities.$error,
                              },attrs:{"placeholder":"Select city","track-by":"id","label":"name","options":_vm.selection.operatingCities,"close-on-select":false,"multiple":true,"limit":3},model:{value:(_vm.model.operatingCities),callback:function ($$v) {_vm.$set(_vm.model, "operatingCities", $$v)},expression:"model.operatingCities"}},[_c('span',{staticClass:"sts-danger",attrs:{"slot":"noResult"},slot:"noResult"},[_vm._v("Sorry, no matching options.")])]),_vm._v(" "),(
                                _vm.isSubmitted &&
                                !_vm.$v.model.operatingCities.required
                              )?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("\n                              Operating cities is required\n                            ")]):_vm._e()],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("\n                              Currency, Decimal & Time Format\n                            ")]),_vm._v(" "),_c('v-select',{staticClass:"v-search-select",class:{
                                'field-error':
                                  _vm.isSubmitted &&
                                  _vm.$v.model.regionFormatId.$error,
                              },attrs:{"placeholder":"","label":"label","options":_vm.regionFormats,"clearable":true,"searchable":true,"filterable":true,"reduce":function (option) { return option.id; },"disabled":_vm.isViewOnly},model:{value:(_vm.model.regionFormatId),callback:function ($$v) {_vm.$set(_vm.model, "regionFormatId", $$v)},expression:"model.regionFormatId"}}),_vm._v(" "),(
                                _vm.isSubmitted &&
                                !_vm.$v.model.regionFormatId.required
                              )?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Region Format is required")]):_vm._e()],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"cursor-pointer w-max-content"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.isSoleProprietor),expression:"model.isSoleProprietor"}],staticClass:"control-checkbox",attrs:{"type":"checkbox"},domProps:{"value":_vm.model.isSoleProprietor,"checked":Array.isArray(_vm.model.isSoleProprietor)?_vm._i(_vm.model.isSoleProprietor,_vm.model.isSoleProprietor)>-1:(_vm.model.isSoleProprietor)},on:{"change":function($event){var $$a=_vm.model.isSoleProprietor,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=_vm.model.isSoleProprietor,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model, "isSoleProprietor", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model, "isSoleProprietor", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model, "isSoleProprietor", $$c)}}}}),_vm._v(" "),_c('span',{staticClass:"pl-5 v-align-middle"},[_vm._v("\n                                Is Sole Proprietor / Independent Operator\n                              ")])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"cursor-pointer w-max-content"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.isMasterOperator),expression:"model.isMasterOperator"}],staticClass:"control-checkbox",attrs:{"type":"checkbox"},domProps:{"value":_vm.model.isMasterOperator,"checked":Array.isArray(_vm.model.isMasterOperator)?_vm._i(_vm.model.isMasterOperator,_vm.model.isMasterOperator)>-1:(_vm.model.isMasterOperator)},on:{"change":function($event){var $$a=_vm.model.isMasterOperator,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=_vm.model.isMasterOperator,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model, "isMasterOperator", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model, "isMasterOperator", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model, "isMasterOperator", $$c)}}}}),_vm._v(" "),_c('span',{staticClass:"pl-5 v-align-middle"},[_vm._v("\n                                Is Master Operator\n                              ")])])])])]),_vm._v(" "),(!_vm.model.isMasterOperator)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Master Operator")]),_vm._v(" "),_c('v-select',{staticClass:"v-search-select",attrs:{"placeholder":"","label":"text","options":_vm.selection.masterOperators,"clearable":true,"searchable":true,"filterable":true,"reduce":function (option) { return option.value; },"disabled":_vm.isViewOnly},model:{value:(_vm.model.masterOperatorId),callback:function ($$v) {_vm.$set(_vm.model, "masterOperatorId", $$v)},expression:"model.masterOperatorId"}})],1)])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"cursor-pointer w-max-content"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.isSalesTaxApplicable),expression:"model.isSalesTaxApplicable"}],staticClass:"control-checkbox",attrs:{"type":"checkbox"},domProps:{"value":_vm.model.isSalesTaxApplicable,"checked":Array.isArray(_vm.model.isSalesTaxApplicable)?_vm._i(_vm.model.isSalesTaxApplicable,_vm.model.isSalesTaxApplicable)>-1:(_vm.model.isSalesTaxApplicable)},on:{"change":function($event){var $$a=_vm.model.isSalesTaxApplicable,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=_vm.model.isSalesTaxApplicable,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model, "isSalesTaxApplicable", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model, "isSalesTaxApplicable", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model, "isSalesTaxApplicable", $$c)}}}}),_vm._v(" "),_c('span',{staticClass:"pl-5 v-align-middle"},[_vm._v("\n                                VAT/Sales Tax Applicable\n                              ")])])])])]),_vm._v(" "),(_vm.model.isSalesTaxApplicable)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("VAT/Sales Tax Number")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.salesTaxNumber),expression:"model.salesTaxNumber"}],staticClass:"form-control",class:{
                                'field-error':
                                  _vm.isSubmitted &&
                                  _vm.$v.model.salesTaxNumber.$error,
                              },attrs:{"type":"text","autocomplete":"off","disabled":_vm.isViewOnly},domProps:{"value":(_vm.model.salesTaxNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "salesTaxNumber", $event.target.value)}}}),_vm._v(" "),(
                                _vm.isSubmitted && _vm.$v.model.salesTaxNumber.$error
                              )?_c('div',[(!_vm.$v.model.salesTaxNumber.required)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Sales Tax No. is required")]):_vm._e(),_vm._v(" "),(!_vm.$v.model.salesTaxNumber.maxLength)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Sales Tax No. must be less than\n                                "+_vm._s(_vm.$v.model.salesTaxNumber.$params.maxLength
                                    .max)+"\n                                characters")]):_vm._e()]):_vm._e()])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("Company City")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.city),expression:"model.city"}],staticClass:"form-control",class:{
                                'field-error':
                                  _vm.isSubmitted && _vm.$v.model.city.$error,
                              },attrs:{"type":"text","autocomplete":"off","disabled":_vm.isViewOnly},domProps:{"value":(_vm.model.city)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "city", $event.target.value)}}}),_vm._v(" "),(_vm.isSubmitted && _vm.$v.model.city.$error)?_c('div',[(!_vm.$v.model.city.required)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("City is required")]):_vm._e(),_vm._v(" "),(!_vm.$v.model.city.maxLength)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("City must be less than\n                                "+_vm._s(_vm.$v.model.city.$params.maxLength.max)+"\n                                characters")]):_vm._e()]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("Company Address")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.location.address),expression:"location.address"}],staticClass:"form-control",class:{
                                'field-error':
                                  _vm.isSubmitted && _vm.$v.location.address.$error,
                              },attrs:{"rows":"4","autocomplete":"off"},domProps:{"value":(_vm.location.address)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.location, "address", $event.target.value)}}}),_vm._v(" "),(
                                _vm.isSubmitted && !_vm.$v.location.address.required
                              )?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Address is required")]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('button',{staticClass:"btn btn-default",attrs:{"type":"button","id":"btn-map"},on:{"click":function($event){$event.preventDefault();return _vm.openMapModal()}}},[_c('i',{staticClass:"ic-map"}),_vm._v("\n                            Select Location by Map\n                          ")])])])]),_vm._v(" "),_c('div',{staticClass:"tab-pane fade",class:[_vm.activeTab === 'contact' ? 'in active' : ''],attrs:{"id":"provider-contact-person"}},[_vm._l((_vm.model.contactPeople),function(person,personIndex){return _c('div',{key:personIndex},[_c('h4',[_vm._v("Contact Person")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("Select Title")]),_vm._v(" "),_c('div',{staticClass:"btn-group btn-group-toggle",attrs:{"data-toggle":"buttons"}},_vm._l((_vm.titles),function(item,titleIndex){return _c('label',{key:titleIndex,staticClass:"btn",class:{
                                active: person.title === item.value,
                                'field-error':
                                  _vm.isSubmitted &&
                                  _vm.$v.model.contactPeople.$each[personIndex]
                                    .title.$error,
                              },on:{"click":function($event){person.title = item.value}}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(person.title),expression:"person.title"}],attrs:{"type":"radio","autocomplete":"off"},domProps:{"value":item.value,"checked":person.title === item.value,"checked":_vm._q(person.title,item.value)},on:{"change":function($event){return _vm.$set(person, "title", item.value)}}}),_vm._v("\n                              "+_vm._s(item.text)+"\n                            ")])}),0),_vm._v(" "),(
                              _vm.isSubmitted &&
                              !_vm.$v.model.contactPeople.$each[personIndex].title
                                .required
                            )?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Title is required")]):_vm._e()]),_vm._v(" "),(person.title === 'Other')?_c('div',{staticClass:"form-group"},[_c('label',{},[_vm._v("Title")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(person.otherTitle),expression:"person.otherTitle"}],staticClass:"form-control alphabets-only",attrs:{"type":"text","autocomplete":"off"},domProps:{"value":(person.otherTitle)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(person, "otherTitle", $event.target.value)}}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("Full Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(person.fullName),expression:"person.fullName"}],staticClass:"form-control alphabets-characters-only",class:{
                              'field-error':
                                _vm.isSubmitted &&
                                _vm.$v.model.contactPeople.$each[personIndex]
                                  .fullName.$error,
                            },attrs:{"type":"text","autocomplete":"off","disabled":_vm.isViewOnly},domProps:{"value":(person.fullName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(person, "fullName", $event.target.value)}}}),_vm._v(" "),(
                              _vm.isSubmitted &&
                              _vm.$v.model.contactPeople.$each[personIndex]
                                .fullName.$error
                            )?_c('div',[(
                                !_vm.$v.model.contactPeople.$each[personIndex]
                                  .fullName.required
                              )?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Full Name is required")]):_vm._e(),_vm._v(" "),(
                                !_vm.$v.model.contactPeople.$each[personIndex]
                                  .fullName.maxLength
                              )?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Full Name must be less than\n                              "+_vm._s(_vm.$v.model.contactPeople.$each[personIndex]
                                  .fullName.$params.maxLength.max)+"\n                              characters")]):_vm._e()]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("Email")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(person.email),expression:"person.email"}],staticClass:"form-control",class:{
                              'field-error':
                                _vm.isSubmitted &&
                                _vm.$v.model.contactPeople.$each[personIndex]
                                  .email.$error,
                            },attrs:{"type":"text","autocomplete":"off","disabled":_vm.isViewOnly,"placeholder":"e.g youremail@gmail.com"},domProps:{"value":(person.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(person, "email", $event.target.value)}}}),_vm._v(" "),(
                              _vm.isSubmitted &&
                              _vm.$v.model.contactPeople.$each[personIndex].email
                                .$error
                            )?_c('div',[(
                                !_vm.$v.model.contactPeople.$each[personIndex]
                                  .email.required
                              )?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Email is required")]):_vm._e(),_vm._v(" "),(
                                !_vm.$v.model.contactPeople.$each[personIndex]
                                  .email.email
                              )?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Email is invalid")]):_vm._e(),_vm._v(" "),(
                                !_vm.$v.model.contactPeople.$each[personIndex]
                                  .email.maxLength
                              )?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Email must be less than\n                              "+_vm._s(_vm.$v.model.contactPeople.$each[personIndex]
                                  .email.$params.maxLength.max)+"\n                              characters")]):_vm._e()]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Alternate Email")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(person.alternateEmail),expression:"person.alternateEmail"}],staticClass:"form-control",class:{
                              'field-error':
                                _vm.isSubmitted &&
                                _vm.$v.model.contactPeople.$each[personIndex]
                                  .alternateEmail.$error,
                            },attrs:{"type":"text","autocomplete":"off","disabled":_vm.isViewOnly,"placeholder":"e.g youremail@gmail.com"},domProps:{"value":(person.alternateEmail)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(person, "alternateEmail", $event.target.value)}}}),_vm._v(" "),(
                              _vm.isSubmitted &&
                              _vm.$v.model.contactPeople.$each[personIndex]
                                .alternateEmail.$error
                            )?_c('div',[(
                                !_vm.$v.model.contactPeople.$each[personIndex]
                                  .alternateEmail.email
                              )?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Email is invalid")]):_vm._e(),_vm._v(" "),(
                                _vm.isSubmitted &&
                                !_vm.$v.model.contactPeople.$each[personIndex]
                                  .alternateEmail.maxLength
                              )?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Alt. Email must be less than\n                              "+_vm._s(_vm.$v.model.contactPeople.$each[personIndex]
                                  .alternateEmail.$params.maxLength.max)+"\n                              characters")]):_vm._e()]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('label',{staticClass:"required"},[_vm._v("Phone")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-5"},[_c('div',{staticClass:"form-group"},[_c('v-select',{staticClass:"v-search-select",class:{
                                      'field-error':
                                        _vm.isSubmitted &&
                                        _vm.$v.model.contactPeople.$each[
                                          personIndex
                                        ].phoneCode.$error,
                                    },attrs:{"placeholder":"","label":"label","options":_vm.phoneCodes,"filter":_vm.searchPhoneCode,"clearable":true,"searchable":true,"filterable":true,"reduce":function (option) { return option.dial; },"disabled":_vm.isViewOnly},scopedSlots:_vm._u([{key:"option",fn:function(option){return [_c('div',{staticClass:"phone-wrapper"},[_c('div',{staticClass:"phone-icon",class:option.icon}),_vm._v(" "),_c('div',{staticClass:"phone-text"},[_vm._v("\n                                          "+_vm._s(option.country)+"\n                                        ")])])]}}],null,true),model:{value:(person.phoneCode),callback:function ($$v) {_vm.$set(person, "phoneCode", $$v)},expression:"person.phoneCode"}}),_vm._v(" "),(
                                      _vm.isSubmitted &&
                                      !_vm.$v.model.contactPeople.$each[
                                        personIndex
                                      ].phoneCode.required
                                    )?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Phone Code is required")]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"col-sm-7"},[_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(person.phoneNumber),expression:"person.phoneNumber"}],staticClass:"form-control numbers-only",class:{
                                      'field-error':
                                        _vm.isSubmitted &&
                                        _vm.$v.model.contactPeople.$each[
                                          personIndex
                                        ].phoneNumber.$error,
                                    },attrs:{"type":"text","autocomplete":"off","disabled":_vm.isViewOnly},domProps:{"value":(person.phoneNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(person, "phoneNumber", $event.target.value)}}}),_vm._v(" "),(
                                      _vm.isSubmitted &&
                                      _vm.$v.model.contactPeople.$each[
                                        personIndex
                                      ].phoneNumber.$error
                                    )?_c('div',[(
                                        !_vm.$v.model.contactPeople.$each[
                                          personIndex
                                        ].phoneNumber.required
                                      )?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Phone Number is required")]):_vm._e(),_vm._v(" "),(
                                        !_vm.$v.model.contactPeople.$each[
                                          personIndex
                                        ].phoneNumber.maxLength
                                      )?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Phone Number must be less than\n                                      "+_vm._s(_vm.$v.model.contactPeople.$each[
                                          personIndex
                                        ].phoneNumber.$params.maxLength.max)+"\n                                      characters")]):_vm._e()]):_vm._e()])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('label',[_vm._v("Alternate Phone")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-5"},[_c('div',{staticClass:"form-group"},[_c('v-select',{staticClass:"v-search-select",attrs:{"placeholder":"","label":"label","options":_vm.phoneCodes,"filter":_vm.searchPhoneCode,"clearable":false,"searchable":true,"filterable":true,"reduce":function (option) { return option.dial; },"disabled":_vm.isViewOnly},scopedSlots:_vm._u([{key:"option",fn:function(option){return [_c('div',{staticClass:"phone-wrapper"},[_c('div',{staticClass:"phone-icon",class:option.icon}),_vm._v(" "),_c('div',{staticClass:"phone-text"},[_vm._v("\n                                          "+_vm._s(option.country)+"\n                                        ")])])]}}],null,true),model:{value:(person.alternatePhoneCode),callback:function ($$v) {_vm.$set(person, "alternatePhoneCode", $$v)},expression:"person.alternatePhoneCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-sm-7"},[_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(person.alternatePhoneNumber),expression:"person.alternatePhoneNumber"}],staticClass:"form-control numbers-only",class:{
                                      'field-error':
                                        _vm.isSubmitted &&
                                        _vm.$v.model.contactPeople.$each[
                                          personIndex
                                        ].alternatePhoneNumber.$error,
                                    },attrs:{"type":"text","autocomplete":"off","disabled":_vm.isViewOnly},domProps:{"value":(person.alternatePhoneNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(person, "alternatePhoneNumber", $event.target.value)}}}),_vm._v(" "),(
                                      !_vm.$v.model.contactPeople.$each[
                                        personIndex
                                      ].alternatePhoneNumber.maxLength
                                    )?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Alt. Phone Number must be less than\n                                    "+_vm._s(_vm.$v.model.contactPeople.$each[
                                        personIndex
                                      ].alternatePhoneNumber.$params.maxLength
                                        .max)+"\n                                    characters")]):_vm._e()])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Job Title")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(person.jobTitle),expression:"person.jobTitle"}],staticClass:"form-control",class:{
                              'field-error':
                                _vm.isSubmitted &&
                                _vm.$v.model.contactPeople.$each[personIndex]
                                  .jobTitle.$error,
                            },attrs:{"type":"text","autocomplete":"off","disabled":_vm.isViewOnly},domProps:{"value":(person.jobTitle)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(person, "jobTitle", $event.target.value)}}}),_vm._v(" "),(
                              _vm.isSubmitted &&
                              !_vm.$v.model.contactPeople.$each[personIndex]
                                .jobTitle.maxLength
                            )?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Job Title must be less than\n                            "+_vm._s(_vm.$v.model.contactPeople.$each[personIndex]
                                .jobTitle.$params.maxLength.max)+"\n                            characters")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[(
                              _vm.model.contactPeople &&
                              _vm.model.contactPeople.length > 0
                            )?_c('button',{staticClass:"btn btn-default sts-danger",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.removeContactPerson(personIndex)}}},[_vm._v("\n                            Remove\n                          ")]):_vm._e()])])}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[(
                              _vm.model.contactPeople &&
                              _vm.model.contactPeople.length < 4
                            )?_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.addContactPerson()}}},[_vm._v("\n                            Add\n                          ")]):_vm._e()])])],2),_vm._v(" "),_c('div',{staticClass:"tab-pane fade",class:[_vm.activeTab === 'payment' ? 'in active' : ''],attrs:{"id":"provider-payment"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"cursor-pointer w-max-content"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.paymentMethod),expression:"model.paymentMethod"}],staticClass:"control-radio",attrs:{"type":"radio","name":"paymentMethod","value":"Unspecified"},domProps:{"checked":_vm._q(_vm.model.paymentMethod,"Unspecified")},on:{"change":function($event){return _vm.$set(_vm.model, "paymentMethod", "Unspecified")}}}),_vm._v(" "),_c('span',{staticClass:"pl-5 font-weight-normal v-align-middle"},[_vm._v("\n                                None\n                              ")])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"cursor-pointer w-max-content"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.paymentMethod),expression:"model.paymentMethod"}],staticClass:"control-radio",attrs:{"type":"radio","name":"paymentMethod","value":"BankTransfer"},domProps:{"checked":_vm._q(_vm.model.paymentMethod,"BankTransfer")},on:{"change":function($event){return _vm.$set(_vm.model, "paymentMethod", "BankTransfer")}}}),_vm._v(" "),_c('span',{staticClass:"pl-5 font-weight-normal v-align-middle"},[_vm._v("\n                                Bank Transfer\n                              ")])])])])]),_vm._v(" "),(_vm.model.paymentMethod === 'BankTransfer')?_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("Account Holder Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.bankConfiguration.accountOwner),expression:"model.bankConfiguration.accountOwner"}],staticClass:"form-control",class:{
                                  'field-error':
                                    _vm.isSubmitted &&
                                    _vm.$v.model.bankConfiguration.accountOwner
                                      .$error,
                                },attrs:{"type":"text","autocomplete":"off","disabled":_vm.isViewOnly},domProps:{"value":(_vm.model.bankConfiguration.accountOwner)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model.bankConfiguration, "accountOwner", $event.target.value)}}}),_vm._v(" "),(
                                  _vm.isSubmitted &&
                                  _vm.$v.model.bankConfiguration.accountOwner
                                    .$error
                                )?_c('div',[(
                                    !_vm.$v.model.bankConfiguration.accountOwner
                                      .required
                                  )?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Account Owner is required")]):_vm._e(),_vm._v(" "),(
                                    !_vm.$v.model.bankConfiguration.accountOwner
                                      .maxLength
                                  )?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Account Owner must be less than\n                                  "+_vm._s(_vm.$v.model.bankConfiguration.accountOwner
                                      .$params.maxLength.max)+"\n                                  characters")]):_vm._e()]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("Account Number")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(
                                  _vm.model.bankConfiguration.accountNumber
                                ),expression:"\n                                  model.bankConfiguration.accountNumber\n                                "}],staticClass:"form-control",class:{
                                  'field-error':
                                    _vm.isSubmitted &&
                                    _vm.$v.model.bankConfiguration.accountNumber
                                      .$error,
                                },attrs:{"type":"text","autocomplete":"off","disabled":_vm.isViewOnly},domProps:{"value":(
                                  _vm.model.bankConfiguration.accountNumber
                                )},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model.bankConfiguration, "accountNumber", $event.target.value)}}}),_vm._v(" "),(
                                  _vm.isSubmitted &&
                                  _vm.$v.model.bankConfiguration.accountNumber
                                    .$error
                                )?_c('div',[(
                                    !_vm.$v.model.bankConfiguration.accountNumber
                                      .required
                                  )?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Account Number is required")]):_vm._e(),_vm._v(" "),(
                                    !_vm.$v.model.bankConfiguration.accountNumber
                                      .maxLength
                                  )?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Account Number must be less than\n                                  "+_vm._s(_vm.$v.model.bankConfiguration.accountNumber
                                      .$params.maxLength.max)+"\n                                  characters")]):_vm._e()]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("Bank Name/SWIFT Code")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.bankConfiguration.swift),expression:"model.bankConfiguration.swift"}],staticClass:"form-control",class:{
                                  'field-error':
                                    _vm.isSubmitted &&
                                    _vm.$v.model.bankConfiguration.swift.$error,
                                },attrs:{"type":"text","autocomplete":"off","disabled":_vm.isViewOnly},domProps:{"value":(_vm.model.bankConfiguration.swift)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model.bankConfiguration, "swift", $event.target.value)}}}),_vm._v(" "),(
                                  _vm.isSubmitted &&
                                  !_vm.$v.model.bankConfiguration.swift.maxLength
                                )?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Swift must be less than\n                                "+_vm._s(_vm.$v.model.bankConfiguration.swift.$params
                                    .maxLength.max)+"\n                                characters")]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("International Account Number")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(
                                  _vm.model.bankConfiguration
                                    .internationalAccountNumber
                                ),expression:"\n                                  model.bankConfiguration\n                                    .internationalAccountNumber\n                                "}],staticClass:"form-control",class:{
                                  'field-error':
                                    _vm.isSubmitted &&
                                    _vm.$v.model.bankConfiguration
                                      .internationalAccountNumber.$error,
                                },attrs:{"type":"text","autocomplete":"off","disabled":_vm.isViewOnly},domProps:{"value":(
                                  _vm.model.bankConfiguration
                                    .internationalAccountNumber
                                )},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model.bankConfiguration
                                    , "internationalAccountNumber", $event.target.value)}}}),_vm._v(" "),(
                                  _vm.isSubmitted &&
                                  !_vm.$v.model.bankConfiguration
                                    .internationalAccountNumber.maxLength
                                )?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Intl. Account Number must be less than\n                                "+_vm._s(_vm.$v.model.bankConfiguration
                                    .internationalAccountNumber.$params
                                    .maxLength.max)+"\n                                characters")]):_vm._e()])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"cursor-pointer w-max-content"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.paymentMethod),expression:"model.paymentMethod"}],staticClass:"control-radio",attrs:{"type":"radio","name":"paymentMethod","value":"PayPal"},domProps:{"checked":_vm._q(_vm.model.paymentMethod,"PayPal")},on:{"change":function($event){return _vm.$set(_vm.model, "paymentMethod", "PayPal")}}}),_vm._v(" "),_c('span',{staticClass:"pl-5 font-weight-normal v-align-middle"},[_vm._v("\n                                PayPal\n                              ")])])])])]),_vm._v(" "),(_vm.model.paymentMethod === 'PayPal')?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("PayPal Email")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.paypalConfiguration.email),expression:"model.paypalConfiguration.email"}],staticClass:"form-control",class:{
                                'field-error':
                                  _vm.isSubmitted &&
                                  _vm.$v.model.paypalConfiguration.email.$error,
                              },attrs:{"type":"text","autocomplete":"off","disabled":_vm.isViewOnly},domProps:{"value":(_vm.model.paypalConfiguration.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model.paypalConfiguration, "email", $event.target.value)}}}),_vm._v(" "),(
                                _vm.isSubmitted &&
                                _vm.$v.model.paypalConfiguration.email.$error
                              )?_c('div',[(
                                  !_vm.$v.model.paypalConfiguration.email.required
                                )?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Email is required")]):_vm._e(),_vm._v(" "),(
                                  !_vm.$v.model.paypalConfiguration.email
                                    .maxLength
                                )?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Email must be less than\n                                "+_vm._s(_vm.$v.model.paypalConfiguration.email.$params
                                    .maxLength.max)+"\n                                characters")]):_vm._e()]):_vm._e()])])]):_vm._e(),_vm._v(" "),_vm._m(3)])]),_vm._v(" "),(!_vm.isViewOnly)?_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("\n                      "+_vm._s(_vm.isUpdate ? "Save Changes" : "Save")+"\n                    ")])]):_vm._e()])])])])])])])]),_vm._v(" "),_c('div',{ref:"mapmodal",staticClass:"modal fade",attrs:{"role":"dialog"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header modal-new",class:{ update: _vm.isUpdate },staticStyle:{"padding-bottom":"10px"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-10"},[_c('h4',[_vm._v("Provider Location")]),_vm._v(" "),(_vm.model.modifiedDate)?_c('h6',[_vm._v("\n                Last Updated: "+_vm._s(_vm.model.modifiedDate.stringFullDate)+"\n              ")]):_vm._e()]),_vm._v(" "),_vm._m(4)])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"gmap-wrapper"},[_vm._m(5),_vm._v(" "),_c('div',{attrs:{"id":"map"}}),_vm._v(" "),_c('div',{staticClass:"modal-footer text-center"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isViewOnly),expression:"!isViewOnly"}],attrs:{"id":"gmap-custom-control"}},[_c('button',{staticClass:"btn btn-default remove-location",attrs:{"type":"button"}},[_vm._v("\n                  Reset\n                ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary save-location",attrs:{"type":"button"}},[_vm._v("\n                  Apply\n                ")])])])])])])])]),_vm._v(" "),_c('deleteModal',{on:{"submit":_vm.deleteItem,"cancel":_vm.cancelDelete}}),_vm._v(" "),_c('providerDocumentComponent'),_vm._v(" "),_c('div',{ref:"previewModal",staticClass:"modal fade",attrs:{"role":"dialog"}},[_c('div',{staticClass:"modal-dialog modal-md custom"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-body repricing-modal"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"d-flex justify-between items-center"},[_c('h4',{staticClass:"title-preview"},[_vm._v(_vm._s(_vm.termsConditions.title))]),_vm._v(" "),_c('button',{staticClass:"close btn-close-modal",attrs:{"type":"button","aria-label":"Close"},on:{"click":function($event){return _vm.closePreviewModal()}}},[_c('i',{staticClass:"ic-close"})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"modal-preview-wrapper"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.termsConditions.content)}})])])])])])])])]),_vm._v(" "),_c('loader',{attrs:{"content":_vm.msg,"visible":_vm.isLoading}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{attrs:{"aria-label":"breadcrumb"}},[_c('ol',{staticClass:"breadcrumb"},[_c('li',{staticClass:"breadcrumb-item"},[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v("Fleet Master")])]),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item active",attrs:{"aria-current":"page"}},[_vm._v("\n                Providers\n              ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pl-30 pull-left"},[_c('h2',[_vm._v("\n                  Providers "),_c('span',[_c('i',{staticClass:"ic-car"})])]),_vm._v(" "),_c('p',[_vm._v("Manage all your suppliers and partners.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-2"},[_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('i',{staticClass:"ic-close"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_vm._v("\n                          Payment will be made in your local currency.\n                        ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-2"},[_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('i',{staticClass:"ic-close"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pac-card",attrs:{"id":"pac-card"}},[_c('div',{attrs:{"id":"pac-container"}},[_c('input',{attrs:{"id":"pac-input","type":"text","placeholder":"Enter a location"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/14.b384892b1d13b21b76ec.js